const dictionary = [
	{
		name: 'coralColorNeutralText',
		type: 'color',
		description: ``,
		hsla: 'hsla(0, 0%, 100%, 1)',
		hex: '#ffffff',
		value: 'hsla(0, 0%, 100%, 1)',
		id: 'S:33b4829a83b57d2a91a7e31128d6c6e730ac8c2e,',
	},
	{
		name: 'coralColorNeutralTextInverted',
		type: 'color',
		description: ``,
		hsla: 'hsla(210, 7%, 79%, 1)',
		hex: '#c5c9cd',
		value: 'hsla(210, 7%, 79%, 1)',
		id: 'S:b71edb12b01e59e0e4639aa156b4dd1cf7159ecd,',
	},
	{
		name: 'coralColorNeutralTextWeak',
		type: 'color',
		description: ``,
		hsla: 'hsla(206, 17%, 82%, 1)',
		hex: '#c9d2d9',
		value: 'hsla(206, 17%, 82%, 1)',
		id: 'S:e5707bfe4926aac1b3c73b09e06bf34bbcfff67e,',
	},
	{
		name: 'coralColorNeutralTextDisabled',
		type: 'color',
		description: ``,
		hsla: 'hsla(207, 11%, 64%, 1)',
		hex: '#99a4ad',
		value: 'hsla(207, 11%, 64%, 1)',
		id: 'S:cdb1ac42dc5c74e95ba1ad58d75c4dcbf9a8d0a8,',
	},
	{
		name: 'coralColorNeutralBackground',
		type: 'color',
		description: ``,
		hsla: 'hsla(206, 17%, 18%, 1)',
		hex: '#262f36',
		value: 'hsla(206, 17%, 18%, 1)',
		id: 'S:9ef16391a1cd63272e12e6e559a07e1bdde8d98c,',
	},
	{
		name: 'coralColorNeutralBackgroundDisabled',
		type: 'color',
		description: ``,
		hsla: 'hsla(210, 17%, 16%, 1)',
		hex: '#222930',
		value: 'hsla(210, 17%, 16%, 1)',
		id: 'S:e8339f431f04d742f8db2e6c2beced31402ffd3e,',
	},
	{
		name: 'coralColorNeutralBackgroundMedium',
		type: 'color',
		description: ``,
		hsla: 'hsla(208, 18%, 21%, 1)',
		hex: '#2c363f',
		value: 'hsla(208, 18%, 21%, 1)',
		id: 'S:608470870204c2776675f5d5745fc81ae3136466,',
	},
	{
		name: 'coralColorNeutralBackgroundStrong',
		type: 'color',
		description: ``,
		hsla: 'hsla(208, 18%, 14%, 1)',
		hex: '#1d242a',
		value: 'hsla(208, 18%, 14%, 1)',
		id: 'S:1ab9d51f56f73bcdf1669ac742476f4153bc4081,',
	},
	{
		name: 'coralColorNeutralBorder',
		type: 'color',
		description: ``,
		hsla: 'hsla(206, 17%, 82%, 1)',
		hex: '#c9d2d9',
		value: 'hsla(206, 17%, 82%, 1)',
		id: 'S:6bf9d120b89396822b4ef521cd8835a00af20a67,',
	},
	{
		name: 'coralColorNeutralBorderWeak',
		type: 'color',
		description: ``,
		hsla: 'hsla(207, 18%, 34%, 1)',
		hex: '#475866',
		value: 'hsla(207, 18%, 34%, 1)',
		id: 'S:4cad0f16d923abe960465c5632c01d0c583cf1b1,',
	},
	{
		name: 'coralColorNeutralBorderWeakHover',
		type: 'color',
		description: ``,
		hsla: 'hsla(207, 18%, 44%, 1)',
		hex: '#5c7284',
		value: 'hsla(207, 18%, 44%, 1)',
		id: 'S:21009d87761d33a94890fa531c68a1a2b844a4e9,',
	},
	{
		name: 'coralColorNeutralBorderDisabled',
		type: 'color',
		description: ``,
		hsla: 'hsla(208, 11%, 35%, 1)',
		hex: '#505a63',
		value: 'hsla(208, 11%, 35%, 1)',
		id: 'S:7f7f778874b7664a5544e2bfb2dc3eeb6541764c,',
	},
	{
		name: 'coralColorAccentText',
		type: 'color',
		description: ``,
		hsla: 'hsla(198, 72%, 65%, 1)',
		hex: '#66bfe6',
		value: 'hsla(198, 72%, 65%, 1)',
		id: 'S:08cc47c47088d53c52531343029ad926dc510f9a,',
	},
	{
		name: 'coralColorAccentTextHover',
		type: 'color',
		description: ``,
		hsla: 'hsla(198, 72%, 55%, 1)',
		hex: '#3aaddf',
		value: 'hsla(198, 72%, 55%, 1)',
		id: 'S:cb35f0ed6b95b863d8ab60b2094ec97f540d4b57,',
	},
	{
		name: 'coralColorAccentTextActive',
		type: 'color',
		description: ``,
		hsla: 'hsla(198, 72%, 45%, 1)',
		hex: '#2093c5',
		value: 'hsla(198, 72%, 45%, 1)',
		id: 'S:25709adb7388e4e36887f4e186ed83363ccfdab2,',
	},
	{
		name: 'coralColorAccentTextWeak',
		type: 'color',
		description: ``,
		hsla: 'hsla(207, 18%, 24%, 1)',
		hex: '#323e48',
		value: 'hsla(207, 18%, 24%, 1)',
		id: 'S:d7d4b99d4b04146e8756a987ed5829affe0ecb3e,',
	},
	{
		name: 'coralColorAccentTextWeakHover',
		type: 'color',
		description: ``,
		hsla: 'hsla(199, 71%, 15%, 1)',
		hex: '#0b3142',
		value: 'hsla(199, 71%, 15%, 1)',
		id: 'S:aba0eb56f534ab5d12de536fac73fc502b102a8e,',
	},
	{
		name: 'coralColorAccentTextWeakActive',
		type: 'color',
		description: ``,
		hsla: 'hsla(199, 73%, 10%, 1)',
		hex: '#07202c',
		value: 'hsla(199, 73%, 10%, 1)',
		id: 'S:dc054ee71c9ba3d9c308762bd2a498dec7c66cf0,',
	},
	{
		name: 'coralColorAccentTextStrong',
		type: 'color',
		description: ``,
		hsla: 'hsla(198, 72%, 75%, 1)',
		hex: '#91d1ed',
		value: 'hsla(198, 72%, 75%, 1)',
		id: 'S:6859abb1d07943abbfc8d9aa3df44b8c9fdf1f3e,',
	},
	{
		name: 'coralColorAccentTextStrongHover',
		type: 'color',
		description: ``,
		hsla: 'hsla(198, 72%, 65%, 1)',
		hex: '#66bfe6',
		value: 'hsla(198, 72%, 65%, 1)',
		id: 'S:d7afea39d1cbc3b2eff9428c58ac8b080f9881d3,',
	},
	{
		name: 'coralColorAccentTextStrongActive',
		type: 'color',
		description: ``,
		hsla: 'hsla(198, 72%, 55%, 1)',
		hex: '#3aaddf',
		value: 'hsla(198, 72%, 55%, 1)',
		id: 'S:e56ee16357f44629bccdcdcacab8dae6387e9933,',
	},
	{
		name: 'coralColorAccentBackground',
		type: 'color',
		description: ``,
		hsla: 'hsla(198, 72%, 25%, 1)',
		hex: '#12516d',
		value: 'hsla(198, 72%, 25%, 1)',
		id: 'S:d0bc41ad3ff985739cc159963538d13d49b68d3e,',
	},
	{
		name: 'coralColorAccentBackgroundHover',
		type: 'color',
		description: ``,
		hsla: 'hsla(199, 78%, 20%, 1)',
		hex: '#0b425b',
		value: 'hsla(199, 78%, 20%, 1)',
		id: 'S:d207ec73a23f1ed631122c5586e13266a8445538,',
	},
	{
		name: 'coralColorAccentBackgroundActive',
		type: 'color',
		description: ``,
		hsla: 'hsla(199, 73%, 10%, 1)',
		hex: '#07202c',
		value: 'hsla(199, 73%, 10%, 1)',
		id: 'S:6417c23a879b7dbfd822c317ac052bac965cc359,',
	},
	{
		name: 'coralColorAccentBackgroundWeak',
		type: 'color',
		description: ``,
		hsla: 'hsla(207, 18%, 24%, 1)',
		hex: '#323e48',
		value: 'hsla(207, 18%, 24%, 1)',
		id: 'S:90cc9c9957316ceecd890fdd0e2d522611937f8f,',
	},
	{
		name: 'coralColorAccentBackgroundWeakHover',
		type: 'color',
		description: ``,
		hsla: 'hsla(199, 71%, 15%, 1)',
		hex: '#0b3142',
		value: 'hsla(199, 71%, 15%, 1)',
		id: 'S:e2831e1903246c2edf0fc8c5923cd3da3a9f1689,',
	},
	{
		name: 'coralColorAccentBackgroundWeakActive',
		type: 'color',
		description: ``,
		hsla: 'hsla(199, 73%, 10%, 1)',
		hex: '#07202c',
		value: 'hsla(199, 73%, 10%, 1)',
		id: 'S:fa263d6acd99cc673c83d414bbe7f7edb790950f,',
	},
	{
		name: 'coralColorAccentBackgroundStrong',
		type: 'color',
		description: ``,
		hsla: 'hsla(198, 72%, 75%, 1)',
		hex: '#91d1ed',
		value: 'hsla(198, 72%, 75%, 1)',
		id: 'S:b5b4e2fdc443b96425a226e8fb6e9c48a0274ba5,',
	},
	{
		name: 'coralColorAccentBackgroundStrongHover',
		type: 'color',
		description: ``,
		hsla: 'hsla(198, 72%, 65%, 1)',
		hex: '#66bfe6',
		value: 'hsla(198, 72%, 65%, 1)',
		id: 'S:d63101a73ff03405385f907600450a8ce06960be,',
	},
	{
		name: 'coralColorAccentBackgroundStrongActive',
		type: 'color',
		description: ``,
		hsla: 'hsla(198, 72%, 55%, 1)',
		hex: '#3aaddf',
		value: 'hsla(198, 72%, 55%, 1)',
		id: 'S:96cf73d9f20b39a9d95916fcb05cddee14924948,',
	},
	{
		name: 'coralColorAccentBorder',
		type: 'color',
		description: ``,
		hsla: 'hsla(198, 72%, 75%, 1)',
		hex: '#91d1ed',
		value: 'hsla(198, 72%, 75%, 1)',
		id: 'S:774e5e42c3eea5b3365ec43a61207f077866b031,',
	},
	{
		name: 'coralColorAccentBorderHover',
		type: 'color',
		description: ``,
		hsla: 'hsla(198, 72%, 65%, 1)',
		hex: '#66bfe6',
		value: 'hsla(198, 72%, 65%, 1)',
		id: 'S:851b249f5bcea2d55cbe21f82081cbe6f5c3e43a,',
	},
	{
		name: 'coralColorAccentBorderActive',
		type: 'color',
		description: ``,
		hsla: 'hsla(199, 72%, 55%, 1)',
		hex: '#3aacdf',
		value: 'hsla(199, 72%, 55%, 1)',
		id: 'S:d6f90237a2053850f92758d916244747eedbe2ff,',
	},
	{
		name: 'coralColorDangerText',
		type: 'color',
		description: ``,
		hsla: 'hsla(2, 95%, 74%, 1)',
		hex: '#fc827e',
		value: 'hsla(2, 95%, 74%, 1)',
		id: 'S:5b9635ad4f2e4ee60dee9881a5f465e9dac2de12,',
	},
	{
		name: 'coralColorDangerTextHover',
		type: 'color',
		description: ``,
		hsla: 'hsla(2, 95%, 69%, 1)',
		hex: '#fb6964',
		value: 'hsla(2, 95%, 69%, 1)',
		id: 'S:cd14f48a94af225223a3bd795c6c1b08552a3638,',
	},
	{
		name: 'coralColorDangerTextActive',
		type: 'color',
		description: ``,
		hsla: 'hsla(2, 96%, 64%, 1)',
		hex: '#fb514c',
		value: 'hsla(2, 96%, 64%, 1)',
		id: 'S:d5a4ccb7904bb51f3737379e8b1963bd1b5ce1f1,',
	},
	{
		name: 'coralColorDangerTextWeak',
		type: 'color',
		description: ``,
		hsla: 'hsla(207, 18%, 24%, 1)',
		hex: '#323e48',
		value: 'hsla(207, 18%, 24%, 1)',
		id: 'S:262b86066bc2a1bd3392903a4fa89219f54de1e5,',
	},
	{
		name: 'coralColorDangerTextWeakHover',
		type: 'color',
		description: ``,
		hsla: 'hsla(358, 96%, 18%, 1)',
		hex: '#590205',
		value: 'hsla(358, 96%, 18%, 1)',
		id: 'S:8cc42ad3d76e34a7e82a06c02e212315af6205d5,',
	},
	{
		name: 'coralColorDangerTextWeakActive',
		type: 'color',
		description: ``,
		hsla: 'hsla(357, 97%, 13%, 1)',
		hex: '#410104',
		value: 'hsla(357, 97%, 13%, 1)',
		id: 'S:dff099effde644c9686227fead9ec34d060fed6b,',
	},
	{
		name: 'coralColorDangerTextStrong',
		type: 'color',
		description: ``,
		hsla: 'hsla(359, 100%, 78%, 1)',
		hex: '#ff8f91',
		value: 'hsla(359, 100%, 78%, 1)',
		id: 'S:4a03b0a2376fe5b4b5d7a518cbe228a106e2509c,',
	},
	{
		name: 'coralColorDangerTextStrongHover',
		type: 'color',
		description: ``,
		hsla: 'hsla(359, 100%, 73%, 1)',
		hex: '#ff7578',
		value: 'hsla(359, 100%, 73%, 1)',
		id: 'S:482fe4c679a7df1ea0bab272ea9981626bf29954,',
	},
	{
		name: 'coralColorDangerTextStrongActive',
		type: 'color',
		description: ``,
		hsla: 'hsla(359, 100%, 68%, 1)',
		hex: '#ff5c5f',
		value: 'hsla(359, 100%, 68%, 1)',
		id: 'S:1c90229b88a04809e5aafe15040a2a4a2ff0014b,',
	},
	{
		name: 'coralColorDangerBackground',
		type: 'color',
		description: ``,
		hsla: 'hsla(358, 96%, 18%, 1)',
		hex: '#590205',
		value: 'hsla(358, 96%, 18%, 1)',
		id: 'S:30752ec1928f789f0cdae58ef69ce17eba4f5d14,',
	},
	{
		name: 'coralColorDangerBackgroundHover',
		type: 'color',
		description: ``,
		hsla: 'hsla(357, 97%, 13%, 1)',
		hex: '#410104',
		value: 'hsla(357, 97%, 13%, 1)',
		id: 'S:5d28e3bfceaffdcb7eed504fd2a61881346db2ab,',
	},
	{
		name: 'coralColorDangerBackgroundActive',
		type: 'color',
		description: ``,
		hsla: 'hsla(358, 95%, 8%, 1)',
		hex: '#280102',
		value: 'hsla(358, 95%, 8%, 1)',
		id: 'S:28091ca1f7f258e3747e85bef0fd785b7993c41b,',
	},
	{
		name: 'coralColorDangerBackgroundWeak',
		type: 'color',
		description: ``,
		hsla: 'hsla(207, 18%, 24%, 1)',
		hex: '#323e48',
		value: 'hsla(207, 18%, 24%, 1)',
		id: 'S:3aac206c50736c0b809b2ce622eda1614e2c390a,',
	},
	{
		name: 'coralColorDangerBackgroundWeakHover',
		type: 'color',
		description: ``,
		hsla: 'hsla(358, 96%, 18%, 1)',
		hex: '#590205',
		value: 'hsla(358, 96%, 18%, 1)',
		id: 'S:59e6211c6964e6d40a75e79c3cbd7a641983287e,',
	},
	{
		name: 'coralColorDangerBackgroundWeakActive',
		type: 'color',
		description: ``,
		hsla: 'hsla(357, 97%, 13%, 1)',
		hex: '#410104',
		value: 'hsla(357, 97%, 13%, 1)',
		id: 'S:cf173dbfeb69ff1be2c2979b7dd24ea59eeaee95,',
	},
	{
		name: 'coralColorDangerBackgroundStrong',
		type: 'color',
		description: ``,
		hsla: 'hsla(359, 100%, 78%, 1)',
		hex: '#ff8f91',
		value: 'hsla(359, 100%, 78%, 1)',
		id: 'S:7951ddfe01c38d9291184437ad1ce6f3e4f421f6,',
	},
	{
		name: 'coralColorDangerBackgroundStrongHover',
		type: 'color',
		description: ``,
		hsla: 'hsla(359, 100%, 73%, 1)',
		hex: '#ff7578',
		value: 'hsla(359, 100%, 73%, 1)',
		id: 'S:d778c6465e775ecabe4636a6c3ace83f16da03bb,',
	},
	{
		name: 'coralColorDangerBackgroundStrongActive',
		type: 'color',
		description: ``,
		hsla: 'hsla(359, 100%, 68%, 1)',
		hex: '#ff5c5f',
		value: 'hsla(359, 100%, 68%, 1)',
		id: 'S:efe81f0518b0281e48adcabe71640a0feb6f47de,',
	},
	{
		name: 'coralColorDangerBorder',
		type: 'color',
		description: ``,
		hsla: 'hsla(359, 100%, 78%, 1)',
		hex: '#ff8f91',
		value: 'hsla(359, 100%, 78%, 1)',
		id: 'S:0cec2ca3a831fbc28fd9a065f38c4844d9b9c153,',
	},
	{
		name: 'coralColorDangerBorderHover',
		type: 'color',
		description: ``,
		hsla: 'hsla(359, 100%, 73%, 1)',
		hex: '#ff7578',
		value: 'hsla(359, 100%, 73%, 1)',
		id: 'S:8693225af66ed3a86bab3985fe0ba6f3b9ce5f20,',
	},
	{
		name: 'coralColorDangerBorderActive',
		type: 'color',
		description: ``,
		hsla: 'hsla(359, 100%, 68%, 1)',
		hex: '#ff5c5f',
		value: 'hsla(359, 100%, 68%, 1)',
		id: 'S:b27aec96b54b0e2fd3dabd0127812d3821c3b3a6,',
	},
	{
		name: 'coralColorSuccessText',
		type: 'color',
		description: ``,
		hsla: 'hsla(110, 50%, 60%, 1)',
		hex: '#77cc66',
		value: 'hsla(110, 50%, 60%, 1)',
		id: 'S:ddc24cf38b47116105cdbdde83e916a6e88191f6,',
	},
	{
		name: 'coralColorSuccessTextHover',
		type: 'color',
		description: ``,
		hsla: 'hsla(110, 45%, 50%, 1)',
		hex: '#59b946',
		value: 'hsla(110, 45%, 50%, 1)',
		id: 'S:afc5e78d6b0188edc09b91af776a861ca87bd15a,',
	},
	{
		name: 'coralColorSuccessTextActive',
		type: 'color',
		description: ``,
		hsla: 'hsla(110, 45%, 40%, 1)',
		hex: '#479438',
		value: 'hsla(110, 45%, 40%, 1)',
		id: 'S:3e16d2a4a600780f62ef6e619d79f01110ffac52,',
	},
	{
		name: 'coralColorSuccessTextWeak',
		type: 'color',
		description: ``,
		hsla: 'hsla(207, 18%, 24%, 1)',
		hex: '#323e48',
		value: 'hsla(207, 18%, 24%, 1)',
		id: 'S:2207e6ca2ae20e6ccf66df42a0747dc886fc64cd,',
	},
	{
		name: 'coralColorSuccessTextWeakHover',
		type: 'color',
		description: ``,
		hsla: 'hsla(109, 50%, 20%, 1)',
		hex: '#224c19',
		value: 'hsla(109, 50%, 20%, 1)',
		id: 'S:f053a69fac1c95dc1fa240a5e358fb13d1441df0,',
	},
	{
		name: 'coralColorSuccessTextWeakActive',
		type: 'color',
		description: ``,
		hsla: 'hsla(109, 51%, 15%, 1)',
		hex: '#1a3a13',
		value: 'hsla(109, 51%, 15%, 1)',
		id: 'S:4eaa477af134fb81a339c90fca411f546c823186,',
	},
	{
		name: 'coralColorSuccessTextStrong',
		type: 'color',
		description: ``,
		hsla: 'hsla(110, 50%, 70%, 1)',
		hex: '#99d98c',
		value: 'hsla(110, 50%, 70%, 1)',
		id: 'S:4bb64d21d4806350f9bb8c7648bf54ca8b778336,',
	},
	{
		name: 'coralColorSuccessTextStrongHover',
		type: 'color',
		description: ``,
		hsla: 'hsla(110, 50%, 60%, 1)',
		hex: '#77cc66',
		value: 'hsla(110, 50%, 60%, 1)',
		id: 'S:08280353077826711ef7e299b5b78d52244e69f4,',
	},
	{
		name: 'coralColorSuccessTextStrongActive',
		type: 'color',
		description: ``,
		hsla: 'hsla(110, 50%, 50%, 1)',
		hex: '#55bf40',
		value: 'hsla(110, 50%, 50%, 1)',
		id: 'S:ef7aa00f229b0d521e9ad9fd67fff4adf9632a5f,',
	},
	{
		name: 'coralColorSuccessBackground',
		type: 'color',
		description: ``,
		hsla: 'hsla(109, 50%, 20%, 1)',
		hex: '#224c19',
		value: 'hsla(109, 50%, 20%, 1)',
		id: 'S:c0f06ce2d8287de9df9faec5f1bee0fb2239970b,',
	},
	{
		name: 'coralColorSuccessBackgroundHover',
		type: 'color',
		description: ``,
		hsla: 'hsla(109, 51%, 15%, 1)',
		hex: '#1a3a13',
		value: 'hsla(109, 51%, 15%, 1)',
		id: 'S:87355975e174a30e50368b9810808dce64711190,',
	},
	{
		name: 'coralColorSuccessBackgroundActive',
		type: 'color',
		description: ``,
		hsla: 'hsla(110, 49%, 10%, 1)',
		hex: '#11260d',
		value: 'hsla(110, 49%, 10%, 1)',
		id: 'S:8ee02349b9dddba7739fb10be04bc72fe0767f29,',
	},
	{
		name: 'coralColorSuccessBackgroundWeak',
		type: 'color',
		description: ``,
		hsla: 'hsla(207, 18%, 24%, 1)',
		hex: '#323e48',
		value: 'hsla(207, 18%, 24%, 1)',
		id: 'S:990829d6c422d85d4ef6d244ea63143d54b0e270,',
	},
	{
		name: 'coralColorSuccessBackgroundWeakHover',
		type: 'color',
		description: ``,
		hsla: 'hsla(109, 50%, 20%, 1)',
		hex: '#224c19',
		value: 'hsla(109, 50%, 20%, 1)',
		id: 'S:2c9006c27dab2aa4eb3fee3b4da90acc2d010e79,',
	},
	{
		name: 'coralColorSuccessBackgroundWeakActive',
		type: 'color',
		description: ``,
		hsla: 'hsla(109, 51%, 15%, 1)',
		hex: '#1a3a13',
		value: 'hsla(109, 51%, 15%, 1)',
		id: 'S:496d934784ba9739f504e57450048c6dd5a98f85,',
	},
	{
		name: 'coralColorSuccessBackgroundStrong',
		type: 'color',
		description: ``,
		hsla: 'hsla(110, 50%, 70%, 1)',
		hex: '#99d98c',
		value: 'hsla(110, 50%, 70%, 1)',
		id: 'S:caab7cb7fd3ef273fb588427f064bb6cdb1f301c,',
	},
	{
		name: 'coralColorSuccessBackgroundStrongHover',
		type: 'color',
		description: ``,
		hsla: 'hsla(110, 50%, 60%, 1)',
		hex: '#77cc66',
		value: 'hsla(110, 50%, 60%, 1)',
		id: 'S:46b7fdb7686322364dc0ffb4f642c7ab1a6b01c2,',
	},
	{
		name: 'coralColorSuccessBackgroundStrongActive',
		type: 'color',
		description: ``,
		hsla: 'hsla(110, 50%, 50%, 1)',
		hex: '#55bf40',
		value: 'hsla(110, 50%, 50%, 1)',
		id: 'S:0b2c05a33bc22a49e5838779a45b5a1d40d75c76,',
	},
	{
		name: 'coralColorSuccessBorder',
		type: 'color',
		description: ``,
		hsla: 'hsla(110, 50%, 70%, 1)',
		hex: '#99d98c',
		value: 'hsla(110, 50%, 70%, 1)',
		id: 'S:41f3cf4696b9214ee67657de66222c9bc1473ddf,',
	},
	{
		name: 'coralColorSuccessBorderHover',
		type: 'color',
		description: ``,
		hsla: 'hsla(110, 50%, 60%, 1)',
		hex: '#77cc66',
		value: 'hsla(110, 50%, 60%, 1)',
		id: 'S:65ba39beb6bb171796560228fbdf7d0e755a6f81,',
	},
	{
		name: 'coralColorSuccessBorderActive',
		type: 'color',
		description: ``,
		hsla: 'hsla(110, 50%, 50%, 1)',
		hex: '#55bf40',
		value: 'hsla(110, 50%, 50%, 1)',
		id: 'S:8a4ea54bac2ed4c8774f5053161ff60c25903537,',
	},
	{
		name: 'coralColorWarningText',
		type: 'color',
		description: ``,
		hsla: 'hsla(27, 97%, 57%, 1)',
		hex: '#fc8727',
		value: 'hsla(27, 97%, 57%, 1)',
		id: 'S:16027484efef3f9d9e75cdbcc7d28420ce0a322c,',
	},
	{
		name: 'coralColorWarningTextHover',
		type: 'color',
		description: ``,
		hsla: 'hsla(27, 97%, 47%, 1)',
		hex: '#ec6c03',
		value: 'hsla(27, 97%, 47%, 1)',
		id: 'S:7610f674bcb4286e88dc19c597fbef3927d806a9,',
	},
	{
		name: 'coralColorWarningTextActive',
		type: 'color',
		description: ``,
		hsla: 'hsla(27, 97%, 37%, 1)',
		hex: '#ba5503',
		value: 'hsla(27, 97%, 37%, 1)',
		id: 'S:e16312eb45e61db89e72b655be0026dd92d5d4c7,',
	},
	{
		name: 'coralColorWarningTextWeak',
		type: 'color',
		description: ``,
		hsla: 'hsla(207, 18%, 24%, 1)',
		hex: '#323e48',
		value: 'hsla(207, 18%, 24%, 1)',
		id: 'S:26a1a656869cfda9e0da9790a8ae579ed538a74c,',
	},
	{
		name: 'coralColorWarningTextWeakHover',
		type: 'color',
		description: ``,
		hsla: 'hsla(22, 84%, 20%, 1)',
		hex: '#5e2808',
		value: 'hsla(22, 84%, 20%, 1)',
		id: 'S:9e653f60207acf7fd4fe7b21a18b5fbcd9f19856,',
	},
	{
		name: 'coralColorWarningTextWeakActive',
		type: 'color',
		description: ``,
		hsla: 'hsla(23, 84%, 15%, 1)',
		hex: '#461e06',
		value: 'hsla(23, 84%, 15%, 1)',
		id: 'S:3e429b2bad134796e748d9639c4690161cde60ea,',
	},
	{
		name: 'coralColorWarningTextStrong',
		type: 'color',
		description: ``,
		hsla: 'hsla(27, 98%, 67%, 1)',
		hex: '#fda359',
		value: 'hsla(27, 98%, 67%, 1)',
		id: 'S:a2e0dc891484bf912ec383de90e726821e3dc002,',
	},
	{
		name: 'coralColorWarningTextStrongHover',
		type: 'color',
		description: ``,
		hsla: 'hsla(27, 97%, 57%, 1)',
		hex: '#fc8726',
		value: 'hsla(27, 97%, 57%, 1)',
		id: 'S:2583276100160b22daf298171af37e9774ae6681,',
	},
	{
		name: 'coralColorWarningTextStrongActive',
		type: 'color',
		description: ``,
		hsla: 'hsla(27, 98%, 47%, 1)',
		hex: '#ed6c03',
		value: 'hsla(27, 98%, 47%, 1)',
		id: 'S:b78bea54c885ecc8465bdcd3b2fbabe63d85e5a5,',
	},
	{
		name: 'coralColorWarningBackground',
		type: 'color',
		description: ``,
		hsla: 'hsla(22, 84%, 20%, 1)',
		hex: '#5e2808',
		value: 'hsla(22, 84%, 20%, 1)',
		id: 'S:8ece51a0dfa9d134906a5e31bf75989cdf39bbab,',
	},
	{
		name: 'coralColorWarningBackgroundHover',
		type: 'color',
		description: ``,
		hsla: 'hsla(22, 84%, 15%, 1)',
		hex: '#471e06',
		value: 'hsla(22, 84%, 15%, 1)',
		id: 'S:fe246dabb565c77eb07dbf4346bc565b5684d3de,',
	},
	{
		name: 'coralColorWarningBackgroundActive',
		type: 'color',
		description: ``,
		hsla: 'hsla(22, 84%, 10%, 1)',
		hex: '#2f1404',
		value: 'hsla(22, 84%, 10%, 1)',
		id: 'S:4daa31745b723bc4edec0700f40b2313aeeb602e,',
	},
	{
		name: 'coralColorWarningBackgroundWeak',
		type: 'color',
		description: ``,
		hsla: 'hsla(207, 18%, 24%, 1)',
		hex: '#323e48',
		value: 'hsla(207, 18%, 24%, 1)',
		id: 'S:503dcdd815de63f67e968186311f4571a06516e8,',
	},
	{
		name: 'coralColorWarningBackgroundWeakHover',
		type: 'color',
		description: ``,
		hsla: 'hsla(22, 84%, 20%, 1)',
		hex: '#5e2808',
		value: 'hsla(22, 84%, 20%, 1)',
		id: 'S:a2ac0699848d6414310a07d8ca6d9e0baca0b974,',
	},
	{
		name: 'coralColorWarningBackgroundWeakActive',
		type: 'color',
		description: ``,
		hsla: 'hsla(23, 84%, 15%, 1)',
		hex: '#461e06',
		value: 'hsla(23, 84%, 15%, 1)',
		id: 'S:1783820c5bd551fb4f2a92b2fa48e3eb10b0d6c1,',
	},
	{
		name: 'coralColorWarningBackgroundStrong',
		type: 'color',
		description: ``,
		hsla: 'hsla(27, 98%, 67%, 1)',
		hex: '#fda359',
		value: 'hsla(27, 98%, 67%, 1)',
		id: 'S:690a5fe2838c1fc9561bca63efa47b989dfb014d,',
	},
	{
		name: 'coralColorWarningBackgroundStrongHover',
		type: 'color',
		description: ``,
		hsla: 'hsla(27, 97%, 57%, 1)',
		hex: '#fc8726',
		value: 'hsla(27, 97%, 57%, 1)',
		id: 'S:719efa488a12d4c1fe27c69be12cf88d9fb50170,',
	},
	{
		name: 'coralColorWarningBackgroundStrongActive',
		type: 'color',
		description: ``,
		hsla: 'hsla(27, 98%, 47%, 1)',
		hex: '#ed6c03',
		value: 'hsla(27, 98%, 47%, 1)',
		id: 'S:c2f433c1cb7d81090205f58a9681988fde520fdf,',
	},
	{
		name: 'coralColorWarningBorder',
		type: 'color',
		description: ``,
		hsla: 'hsla(27, 98%, 67%, 1)',
		hex: '#fda359',
		value: 'hsla(27, 98%, 67%, 1)',
		id: 'S:f51e9dc45e26cdd9230760ef5b2ae40fe0559843,',
	},
	{
		name: 'coralColorWarningBorderHover',
		type: 'color',
		description: ``,
		hsla: 'hsla(27, 97%, 57%, 1)',
		hex: '#fc8726',
		value: 'hsla(27, 97%, 57%, 1)',
		id: 'S:a6b63647daef2a00a3b2f13d7bc355e183bc6445,',
	},
	{
		name: 'coralColorWarningBorderActive',
		type: 'color',
		description: ``,
		hsla: 'hsla(27, 98%, 47%, 1)',
		hex: '#ed6c03',
		value: 'hsla(27, 98%, 47%, 1)',
		id: 'S:1dafbe51ed80a7f2c9939ea49bb062a2e0380e4c,',
	},
	{
		name: 'coralColorAssistiveBackground',
		type: 'color',
		description: ``,
		hsla: 'hsla(208, 20%, 83%, 1)',
		hex: '#ccd5dd',
		value: 'hsla(208, 20%, 83%, 1)',
		id: 'S:2c2c18f8f6baff8d9055995a8f6179e4d7c828f7,',
	},
	{
		name: 'coralColorAssistiveText',
		type: 'color',
		description: ``,
		hsla: 'hsla(208, 18%, 14%, 1)',
		hex: '#1d242a',
		value: 'hsla(208, 18%, 14%, 1)',
		id: 'S:4a279ca6a60e96f9e6497beef63c1e09d834e3f3,',
	},
	{
		name: 'coralColorAssistiveBorder',
		type: 'color',
		description: ``,
		hsla: 'hsla(208, 20%, 63%, 1)',
		hex: '#8ea2b4',
		value: 'hsla(208, 20%, 63%, 1)',
		id: 'S:4339e41773e974fd338ff75e87112f16f3a250de,',
	},
	{
		name: 'coralColorAssistiveBorderFocus',
		type: 'color',
		description: ``,
		hsla: 'hsla(256, 66%, 76%, 1)',
		hex: '#af9aea',
		value: 'hsla(256, 66%, 76%, 1)',
		id: 'S:621e143a2844d1f22688e443488456f2537855f7,',
	},
	{
		name: 'coralColorBrandingBrand',
		type: 'color',
		description: ``,
		hsla: 'hsla(359, 100%, 71%, 1)',
		hex: '#ff6d70',
		value: 'hsla(359, 100%, 71%, 1)',
		id: 'S:a63d2ce05b0960d899aada51ec3b1a3a25c29cd4,',
	},
	{
		name: 'coralColorNeutralBorderHover',
		type: 'color',
		description: ``,
		hsla: 'hsla(206, 17%, 92%, 1)',
		hex: '#e7ebee',
		value: 'hsla(206, 17%, 92%, 1)',
		id: 'S:98967449e63946677235590ad8acd3b5700468aa,',
	},
	{
		name: 'coralColorBetaText',
		type: 'color',
		description: ``,
		hsla: 'hsla(280, 44%, 72%, 1)',
		hex: '#c299d7',
		value: 'hsla(280, 44%, 72%, 1)',
		id: 'S:b948bdc96136c3f6b38375a4b912e9ce5134bf05,',
	},
	{
		name: 'coralColorBetaTextHover',
		type: 'color',
		description: ``,
		hsla: 'hsla(280, 43%, 62%, 1)',
		hex: '#ac74c8',
		value: 'hsla(280, 43%, 62%, 1)',
		id: 'S:bcf2508c6278f94fa3686fe01c981c47c9b65b9d,',
	},
	{
		name: 'coralColorBetaTextActive',
		type: 'color',
		description: ``,
		hsla: 'hsla(280, 44%, 52%, 1)',
		hex: '#974fba',
		value: 'hsla(280, 44%, 52%, 1)',
		id: 'S:4f1a6e2da5a044f3bb69749ebefe4c3925541876,',
	},
	{
		name: 'coralColorBetaIcon',
		type: 'color',
		description: ``,
		hsla: 'hsla(280, 68%, 61%, 1)',
		hex: '#b258df',
		value: 'hsla(280, 68%, 61%, 1)',
		id: 'S:defe72bbfa67005e161dc6f946d8906858d8ea88,',
	},
	{
		name: 'coralColorBetaIconHover',
		type: 'color',
		description: ``,
		hsla: 'hsla(280, 68%, 51%, 1)',
		hex: '#9e2dd7',
		value: 'hsla(280, 68%, 51%, 1)',
		id: 'S:95185feb45d5644ea910487a4eea77456beb3a9a,',
	},
	{
		name: 'coralColorBetaIconActive',
		type: 'color',
		description: ``,
		hsla: 'hsla(280, 67%, 41%, 1)',
		hex: '#8022af',
		value: 'hsla(280, 67%, 41%, 1)',
		id: 'S:3d531b2e194ad4e0a4fd3dea5e4577178b1a3b46,',
	},
	{
		name: 'coralColorBetaTextWeak',
		type: 'color',
		description: ``,
		hsla: 'hsla(207, 18%, 24%, 1)',
		hex: '#323e48',
		value: 'hsla(207, 18%, 24%, 1)',
		id: 'S:9050183d33129b35a164a22e99290643248f24f4,',
	},
	{
		name: 'coralColorBetaTextWeakHover',
		type: 'color',
		description: ``,
		hsla: 'hsla(281, 65%, 24%, 1)',
		hex: '#4d1666',
		value: 'hsla(281, 65%, 24%, 1)',
		id: 'S:f474060639634c5ebf098da1a63271693103d8d2,',
	},
	{
		name: 'coralColorBetaTextWeakActive',
		type: 'color',
		description: ``,
		hsla: 'hsla(280, 64%, 14%, 1)',
		hex: '#2c0d3b',
		value: 'hsla(280, 64%, 14%, 1)',
		id: 'S:8025b590b94570cd48c1d7004b7b04746098c6a0,',
	},
	{
		name: 'coralColorBetaTextStrong',
		type: 'color',
		description: ``,
		hsla: 'hsla(279, 34%, 78%, 1)',
		hex: '#cdb4da',
		value: 'hsla(279, 34%, 78%, 1)',
		id: 'S:50c309d492c16c903c26b15a3b7e62780f15095d,',
	},
	{
		name: 'coralColorBetaTextStrongHover',
		type: 'color',
		description: ``,
		hsla: 'hsla(279, 34%, 68%, 1)',
		hex: '#b692c9',
		value: 'hsla(279, 34%, 68%, 1)',
		id: 'S:9be5f28883b389866ba4c1a1549131ba23daf88a,',
	},
	{
		name: 'coralColorBetaTextStrongActive',
		type: 'color',
		description: ``,
		hsla: 'hsla(280, 34%, 48%, 1)',
		hex: '#8851a4',
		value: 'hsla(280, 34%, 48%, 1)',
		id: 'S:14684ec034fca592e35fac3b01b4651f479c8816,',
	},
	{
		name: 'coralColorBetaBackground',
		type: 'color',
		description: ``,
		hsla: 'hsla(281, 65%, 24%, 1)',
		hex: '#4d1666',
		value: 'hsla(281, 65%, 24%, 1)',
		id: 'S:76b6f1eda003d080b8c65f75c5ca84d07a828766,',
	},
	{
		name: 'coralColorBetaBackgroundHover',
		type: 'color',
		description: ``,
		hsla: 'hsla(280, 64%, 14%, 1)',
		hex: '#2c0d3b',
		value: 'hsla(280, 64%, 14%, 1)',
		id: 'S:47ca987054b92e001c13068c1b18aad101d121ea,',
	},
	{
		name: 'coralColorBetaBackgroundActive',
		type: 'color',
		description: ``,
		hsla: 'hsla(277, 62%, 4%, 1)',
		hex: '#0c0411',
		value: 'hsla(277, 62%, 4%, 1)',
		id: 'S:f161284ccf3e2d852e678cd9d22f9d35d92378e3,',
	},
	{
		name: 'coralColorBetaBackgroundWeak',
		type: 'color',
		description: ``,
		hsla: 'hsla(207, 18%, 24%, 1)',
		hex: '#323e48',
		value: 'hsla(207, 18%, 24%, 1)',
		id: 'S:d12a6c9704d384c9e3c427b24731463361a6226c,',
	},
	{
		name: 'coralColorBetaBackgroundWeakHover',
		type: 'color',
		description: ``,
		hsla: 'hsla(281, 65%, 24%, 1)',
		hex: '#4d1666',
		value: 'hsla(281, 65%, 24%, 1)',
		id: 'S:990df853093263f6b7631d5fcfae2641a5841687,',
	},
	{
		name: 'coralColorBetaBackgroundWeakActive',
		type: 'color',
		description: ``,
		hsla: 'hsla(280, 64%, 14%, 1)',
		hex: '#2c0d3b',
		value: 'hsla(280, 64%, 14%, 1)',
		id: 'S:81938abf28b8a9e267b12f51ddc2dc896f1a0129,',
	},
	{
		name: 'coralColorBetaBackgroundStrong',
		type: 'color',
		description: ``,
		hsla: 'hsla(279, 34%, 78%, 1)',
		hex: '#cdb4da',
		value: 'hsla(279, 34%, 78%, 1)',
		id: 'S:fff57956fe2ef00037830bfacbb0b2dd14de5f7a,',
	},
	{
		name: 'coralColorBetaBackgroundStrongHover',
		type: 'color',
		description: ``,
		hsla: 'hsla(279, 34%, 68%, 1)',
		hex: '#b692c9',
		value: 'hsla(279, 34%, 68%, 1)',
		id: 'S:dd2ba9092ed88e93f12c4a8f799cedb06ae7c6fc,',
	},
	{
		name: 'coralColorBetaBackgroundStrongActive',
		type: 'color',
		description: ``,
		hsla: 'hsla(279, 34%, 48%, 1)',
		hex: '#8751a4',
		value: 'hsla(279, 34%, 48%, 1)',
		id: 'S:79aa01dc99d8a54619b2ac9c3a5e53d3ed0842da,',
	},
	{
		name: 'coralColorBetaBorder',
		type: 'color',
		description: ``,
		hsla: 'hsla(279, 34%, 78%, 1)',
		hex: '#cdb4da',
		value: 'hsla(279, 34%, 78%, 1)',
		id: 'S:6dafe8de2afdf691eb9e2c9fd891604168ce4811,',
	},
	{
		name: 'coralColorBetaBorderHover',
		type: 'color',
		description: ``,
		hsla: 'hsla(279, 34%, 68%, 1)',
		hex: '#b692c9',
		value: 'hsla(279, 34%, 68%, 1)',
		id: 'S:26f9bcc36e2de268604aca546c255dd666a72951,',
	},
	{
		name: 'coralColorBetaBorderActive',
		type: 'color',
		description: ``,
		hsla: 'hsla(279, 34%, 48%, 1)',
		hex: '#8751a4',
		value: 'hsla(279, 34%, 48%, 1)',
		id: 'S:446e25f7ed2d99158809e43c5e70771fb904cdb4,',
	},
	{
		name: 'coralColorAccentIcon',
		type: 'color',
		description: ``,
		hsla: 'hsla(198, 76%, 67%, 1)',
		hex: '#69c4eb',
		value: 'hsla(198, 76%, 67%, 1)',
		id: 'S:0a511b6c26174e70fa690557e04392239f185fba,',
	},
	{
		name: 'coralColorAccentIconHover',
		type: 'color',
		description: ``,
		hsla: 'hsla(198, 76%, 57%, 1)',
		hex: '#3eb2e5',
		value: 'hsla(198, 76%, 57%, 1)',
		id: 'S:4c354076f65713ad230f2917b5ceaff14732a33e,',
	},
	{
		name: 'coralColorAccentIconActive',
		type: 'color',
		description: ``,
		hsla: 'hsla(198, 77%, 47%, 1)',
		hex: '#1c9bd3',
		value: 'hsla(198, 77%, 47%, 1)',
		id: 'S:313a92a79ede7488535525a7babefa5f6ca6a08f,',
	},
	{
		name: 'coralColorDangerIcon',
		type: 'color',
		description: ``,
		hsla: 'hsla(2, 96%, 67%, 1)',
		hex: '#fc5d58',
		value: 'hsla(2, 96%, 67%, 1)',
		id: 'S:0a53ae71956e65051b401603352731ff7c307cc8,',
	},
	{
		name: 'coralColorDangerIconHover',
		type: 'color',
		description: ``,
		hsla: 'hsla(2, 96%, 57%, 1)',
		hex: '#fb2f28',
		value: 'hsla(2, 96%, 57%, 1)',
		id: 'S:84635db99dad36ac4176917f9f06853ad77e7128,',
	},
	{
		name: 'coralColorDangerIconActive',
		type: 'color',
		description: ``,
		hsla: 'hsla(2, 97%, 47%, 1)',
		hex: '#eb0c04',
		value: 'hsla(2, 97%, 47%, 1)',
		id: 'S:a264361d3eee07a1fb417fa991479b91baf5badf,',
	},
	{
		name: 'coralColorSuccessIconActive',
		type: 'color',
		description: ``,
		hsla: 'hsla(110, 61%, 36%, 1)',
		hex: '#369424',
		value: 'hsla(110, 61%, 36%, 1)',
		id: 'S:712126970bb11c2b0eee24e4d2f7a14974a73614,',
	},
	{
		name: 'coralColorSuccessIconHover',
		type: 'color',
		description: ``,
		hsla: 'hsla(110, 62%, 46%, 1)',
		hex: '#45bd2d',
		value: 'hsla(110, 62%, 46%, 1)',
		id: 'S:5bf9f5e0c27fe5a6b99fbe623d9c44441ba092e4,',
	},
	{
		name: 'coralColorSuccessIcon',
		type: 'color',
		description: ``,
		hsla: 'hsla(110, 61%, 56%, 1)',
		hex: '#62d44b',
		value: 'hsla(110, 61%, 56%, 1)',
		id: 'S:2846c4b1447ee8cd3c62bda922faacfa92ebe354,',
	},
	{
		name: 'coralColorWarningIconActive',
		type: 'color',
		description: ``,
		hsla: 'hsla(27, 98%, 19%, 1)',
		hex: '#602c01',
		value: 'hsla(27, 98%, 19%, 1)',
		id: 'S:df78eadc193fc0af351fbcdf92fb5191cee83015,',
	},
	{
		name: 'coralColorWarningIconHover',
		type: 'color',
		description: ``,
		hsla: 'hsla(27, 99%, 29%, 1)',
		hex: '#934301',
		value: 'hsla(27, 99%, 29%, 1)',
		id: 'S:b76056223e9150e85641eacc579c8eb270dd27e2,',
	},
	{
		name: 'coralColorWarningIcon',
		type: 'color',
		description: ``,
		hsla: 'hsla(27, 99%, 49%, 1)',
		hex: '#f87001',
		value: 'hsla(27, 99%, 49%, 1)',
		id: 'S:eeb2b3b50b34a139f61b90c7d250dde2941fb805,',
	},
	{
		name: 'coralColorChartsNeutral',
		type: 'color',
		description: ``,
		hsla: 'hsla(0, 0%, 75%, 1)',
		hex: '#bebebe',
		value: 'hsla(0, 0%, 75%, 1)',
		id: 'S:3286222654ca1fa189b4f6d23ef6444b269c7eb4,',
	},
	{
		name: 'coralColorChartsNeutralWeak',
		type: 'color',
		description: ``,
		hsla: 'hsla(206, 10%, 48%, 1)',
		hex: '#6e7c87',
		value: 'hsla(206, 10%, 48%, 1)',
		id: 'S:41b6028767eb8edd4748bf68f3faf58540b22964,',
	},
	{
		name: 'coralColorChartsNeutralStrong',
		type: 'color',
		description: ``,
		hsla: 'hsla(0, 0%, 88%, 1)',
		hex: '#e0e0e0',
		value: 'hsla(0, 0%, 88%, 1)',
		id: 'S:2d4a8333d042992c165cdf64f4a902843777a48f,',
	},
	{
		name: 'coralColorChartsNeutralHover',
		type: 'color',
		description: ``,
		hsla: 'hsla(0, 0%, 88%, 1)',
		hex: '#e0e0e0',
		value: 'hsla(0, 0%, 88%, 1)',
		id: 'S:7b8e676d8686f34954848519062ec0bb5e5f1b83,',
	},
	{
		name: 'coralColorChartsSuccess',
		type: 'color',
		description: ``,
		hsla: 'hsla(148, 87%, 40%, 1)',
		hex: '#0dbd5e',
		value: 'hsla(148, 87%, 40%, 1)',
		id: 'S:3a91f690ea607ab3aef56e74cf8dddc57ab0bc2a,',
	},
	{
		name: 'coralColorChartsSuccessWeak',
		type: 'color',
		description: ``,
		hsla: 'hsla(130, 52%, 91%, 1)',
		hex: '#dcf4e0',
		value: 'hsla(130, 52%, 91%, 1)',
		id: 'S:223780a9a5f2a5cb182c34ca07f2742a04cb4304,',
	},
	{
		name: 'coralColorChartsSuccessStrong',
		type: 'color',
		description: ``,
		hsla: 'hsla(139, 50%, 22%, 1)',
		hex: '#1c552e',
		value: 'hsla(139, 50%, 22%, 1)',
		id: 'S:5463753f1a581f81bd8256b71ed7f54214bb6b7a,',
	},
	{
		name: 'coralColorChartsSuccessHover',
		type: 'color',
		description: ``,
		hsla: 'hsla(139, 50%, 22%, 1)',
		hex: '#1c552e',
		value: 'hsla(139, 50%, 22%, 1)',
		id: 'S:52b9e9b667e956ec97eefa4de49adaa04feb76f2,',
	},
	{
		name: 'coralColorChartsDanger',
		type: 'color',
		description: ``,
		hsla: 'hsla(4, 89%, 49%, 1)',
		hex: '#ea1b0e',
		value: 'hsla(4, 89%, 49%, 1)',
		id: 'S:8aa39eb7d256925072987a8d3e163188873e9071,',
	},
	{
		name: 'coralColorChartsDangerWeak',
		type: 'color',
		description: ``,
		hsla: 'hsla(359, 69%, 73%, 1)',
		hex: '#e9898a',
		value: 'hsla(359, 69%, 73%, 1)',
		id: 'S:b84cc981e657d448a9ed95cf85ba87d084797c03,',
	},
	{
		name: 'coralColorChartsDangerStrong',
		type: 'color',
		description: ``,
		hsla: 'hsla(359, 62%, 43%, 1)',
		hex: '#b32a2c',
		value: 'hsla(359, 62%, 43%, 1)',
		id: 'S:dd0a23f2abf32c4ab2a239ee9c0a07b56c88acd3,',
	},
	{
		name: 'coralColorChartsDangerHover',
		type: 'color',
		description: ``,
		hsla: 'hsla(359, 62%, 43%, 1)',
		hex: '#b32a2c',
		value: 'hsla(359, 62%, 43%, 1)',
		id: 'S:985f55d1e23f8a03b5037d12f8744d31aa6c2f7d,',
	},
	{
		name: 'coralColorChartsWarning',
		type: 'color',
		description: ``,
		hsla: 'hsla(32, 100%, 56%, 1)',
		hex: '#ff9820',
		value: 'hsla(32, 100%, 56%, 1)',
		id: 'S:3d666ee4ebbec7f8205c44a4045e006f2c96af57,',
	},
	{
		name: 'coralColorChartsWarningWeak',
		type: 'color',
		description: ``,
		hsla: 'hsla(22, 88%, 84%, 1)',
		hex: '#facbb0',
		value: 'hsla(22, 88%, 84%, 1)',
		id: 'S:47beb2ff8bf803a898ebfb47d1f14ef7e75f7939,',
	},
	{
		name: 'coralColorChartsWarningStrong',
		type: 'color',
		description: ``,
		hsla: 'hsla(22, 75%, 42%, 1)',
		hex: '#b9541b',
		value: 'hsla(22, 75%, 42%, 1)',
		id: 'S:427d041b69ecae991aadf370279e07fa91fb651d,',
	},
	{
		name: 'coralColorChartsWarningHover',
		type: 'color',
		description: ``,
		hsla: 'hsla(22, 75%, 42%, 1)',
		hex: '#b9541b',
		value: 'hsla(22, 75%, 42%, 1)',
		id: 'S:f8ddcb4ad465def3975ac99310865a7bac62f871,',
	},
	{
		name: 'coralColorChartsDefault',
		type: 'color',
		description: ``,
		hsla: 'hsla(216, 82%, 48%, 1)',
		hex: '#1667df',
		value: 'hsla(216, 82%, 48%, 1)',
		id: 'S:60a1a68446864f3cda20f69892d512f45d257c3e,',
	},
	{
		name: 'coralColorChartsDefaultWeak',
		type: 'color',
		description: ``,
		hsla: 'hsla(204, 59%, 73%, 1)',
		hex: '#91c2e3',
		value: 'hsla(204, 59%, 73%, 1)',
		id: 'S:40cda1f835eb18ac2dbb9c25e3766a3c4a795470,',
	},
	{
		name: 'coralColorChartsDefaultStrong',
		type: 'color',
		description: ``,
		hsla: 'hsla(204, 92%, 29%, 1)',
		hex: '#06568d',
		value: 'hsla(204, 92%, 29%, 1)',
		id: 'S:360384632f423ad97b3599a78203948f4d88668c,',
	},
	{
		name: 'coralColorChartsDefaultHover',
		type: 'color',
		description: ``,
		hsla: 'hsla(204, 92%, 29%, 1)',
		hex: '#06568d',
		value: 'hsla(204, 92%, 29%, 1)',
		id: 'S:10a7a14035bba005a39f0f50879d431cb2ea20b6,',
	},
	{
		name: 'coralColorChartsColor00',
		type: 'color',
		description: ``,
		hsla: 'hsla(48, 100%, 50%, 1)',
		hex: '#ffcc00',
		value: 'hsla(48, 100%, 50%, 1)',
		id: 'S:6444c98e0c1e7f319436947d28bf99a63e614912,',
	},
	{
		name: 'coralColorChartsColor00Weak',
		type: 'color',
		description: ``,
		hsla: 'hsla(51, 91%, 82%, 1)',
		hex: '#fbefa9',
		value: 'hsla(51, 91%, 82%, 1)',
		id: 'S:4537a26c9b6ea684a4d29538bfb786b3811000ae,',
	},
	{
		name: 'coralColorChartsColor00Strong',
		type: 'color',
		description: ``,
		hsla: 'hsla(48, 82%, 45%, 1)',
		hex: '#d2ad15',
		value: 'hsla(48, 82%, 45%, 1)',
		id: 'S:7f9a6149aeb3d7bad9b69304b971eaf65f2a5e00,',
	},
	{
		name: 'coralColorChartsColor00Hover',
		type: 'color',
		description: ``,
		hsla: 'hsla(48, 82%, 45%, 1)',
		hex: '#d2ad15',
		value: 'hsla(48, 82%, 45%, 1)',
		id: 'S:64444911ef40365ca1cf6a66c7ab9033faaf483d,',
	},
	{
		name: 'coralColorChartsColor01',
		type: 'color',
		description: ``,
		hsla: 'hsla(216, 82%, 48%, 1)',
		hex: '#1667df',
		value: 'hsla(216, 82%, 48%, 1)',
		id: 'S:0808a61f22964ce3a98da38fed10198b83b4f4d7,',
	},
	{
		name: 'coralColorChartsColor01Weak',
		type: 'color',
		description: ``,
		hsla: 'hsla(204, 59%, 73%, 1)',
		hex: '#91c2e3',
		value: 'hsla(204, 59%, 73%, 1)',
		id: 'S:b1d02ff88d90d6d40c020511a5f866f9fd7fc8d5,',
	},
	{
		name: 'coralColorChartsColor01Strong',
		type: 'color',
		description: ``,
		hsla: 'hsla(204, 92%, 29%, 1)',
		hex: '#06568d',
		value: 'hsla(204, 92%, 29%, 1)',
		id: 'S:31acb2e4dc4822b60c188dab643f43a5fe2413a5,',
	},
	{
		name: 'coralColorChartsColor01Hover',
		type: 'color',
		description: ``,
		hsla: 'hsla(204, 92%, 29%, 1)',
		hex: '#06568d',
		value: 'hsla(204, 92%, 29%, 1)',
		id: 'S:ad2a4cb1a59b1747fd3cd56e8867ec500e7958a7,',
	},
	{
		name: 'coralColorChartsColor02',
		type: 'color',
		description: ``,
		hsla: 'hsla(194, 92%, 50%, 1)',
		hex: '#0abef5',
		value: 'hsla(194, 92%, 50%, 1)',
		id: 'S:e8c6c0bfb82c701c4ee7a2314d0920cee5a1912a,',
	},
	{
		name: 'coralColorChartsColor02Weak',
		type: 'color',
		description: ``,
		hsla: 'hsla(194, 91%, 91%, 1)',
		hex: '#d2f3fd',
		value: 'hsla(194, 91%, 91%, 1)',
		id: 'S:d52b809a2b0af6cadd2490dd09b8bab83d2c8623,',
	},
	{
		name: 'coralColorChartsColor02Strong',
		type: 'color',
		description: ``,
		hsla: 'hsla(194, 93%, 32%, 1)',
		hex: '#067b9f',
		value: 'hsla(194, 93%, 32%, 1)',
		id: 'S:128c8c2ee55669ab88695daaf39aa87f43468058,',
	},
	{
		name: 'coralColorChartsColor02Hover',
		type: 'color',
		description: ``,
		hsla: 'hsla(194, 93%, 32%, 1)',
		hex: '#067b9f',
		value: 'hsla(194, 93%, 32%, 1)',
		id: 'S:607e8d26b6d1386d63ac448ef541ab132a1ebd93,',
	},
	{
		name: 'coralColorChartsColor03',
		type: 'color',
		description: ``,
		hsla: 'hsla(140, 39%, 79%, 1)',
		hex: '#b3dec1',
		value: 'hsla(140, 39%, 79%, 1)',
		id: 'S:f997b6392d59d4dff2b95c9c7501decd969f9b2d,',
	},
	{
		name: 'coralColorChartsColor03Weak',
		type: 'color',
		description: ``,
		hsla: 'hsla(138, 40%, 92%, 1)',
		hex: '#e1f2e6',
		value: 'hsla(138, 40%, 92%, 1)',
		id: 'S:66fe7016f8ffa3f4056cab1a9e790b1ab19f4c3f,',
	},
	{
		name: 'coralColorChartsColor03Strong',
		type: 'color',
		description: ``,
		hsla: 'hsla(139, 11%, 35%, 1)',
		hex: '#506356',
		value: 'hsla(139, 11%, 35%, 1)',
		id: 'S:566bd60e0980fef9f6fb4c66ca5ec4bf75273eea,',
	},
	{
		name: 'coralColorChartsColor03Hover',
		type: 'color',
		description: ``,
		hsla: 'hsla(139, 11%, 35%, 1)',
		hex: '#506356',
		value: 'hsla(139, 11%, 35%, 1)',
		id: 'S:827e12c4ea2c3eb405b87a80317edcaeddd9fcd2,',
	},
	{
		name: 'coralColorChartsColor04',
		type: 'color',
		description: ``,
		hsla: 'hsla(148, 87%, 40%, 1)',
		hex: '#0dbd5e',
		value: 'hsla(148, 87%, 40%, 1)',
		id: 'S:9dd7ece1a4c571a01bf0b20f94a339489e78ee3d,',
	},
	{
		name: 'coralColorChartsColor04Weak',
		type: 'color',
		description: ``,
		hsla: 'hsla(130, 52%, 91%, 1)',
		hex: '#dcf4e0',
		value: 'hsla(130, 52%, 91%, 1)',
		id: 'S:a2deb1f02d45c65774c398d6cb83d955ca01de76,',
	},
	{
		name: 'coralColorChartsColor04Strong',
		type: 'color',
		description: ``,
		hsla: 'hsla(139, 50%, 22%, 1)',
		hex: '#1c552e',
		value: 'hsla(139, 50%, 22%, 1)',
		id: 'S:96c0194808536731f972be77edcb091b1342c181,',
	},
	{
		name: 'coralColorChartsColor04Hover',
		type: 'color',
		description: ``,
		hsla: 'hsla(139, 50%, 22%, 1)',
		hex: '#1c552e',
		value: 'hsla(139, 50%, 22%, 1)',
		id: 'S:2022ae101dbead5faca0847a872f4a13fd65ed2c,',
	},
	{
		name: 'coralColorChartsColor05',
		type: 'color',
		description: ``,
		hsla: 'hsla(324, 68%, 71%, 1)',
		hex: '#e884c0',
		value: 'hsla(324, 68%, 71%, 1)',
		id: 'S:c4842c962e6ed3bb8cc392ffef69be86fa4c487c,',
	},
	{
		name: 'coralColorChartsColor05Weak',
		type: 'color',
		description: ``,
		hsla: 'hsla(323, 69%, 95%, 1)',
		hex: '#fbe9f4',
		value: 'hsla(323, 69%, 95%, 1)',
		id: 'S:8898cfa3b0a395430151caaba0953352a6f10a70,',
	},
	{
		name: 'coralColorChartsColor05Strong',
		type: 'color',
		description: ``,
		hsla: 'hsla(324, 28%, 49%, 1)',
		hex: '#a15b85',
		value: 'hsla(324, 28%, 49%, 1)',
		id: 'S:3be3187416a5ab4f68fbe498bd56435968b7b95e,',
	},
	{
		name: 'coralColorChartsColor05Hover',
		type: 'color',
		description: ``,
		hsla: 'hsla(324, 28%, 49%, 1)',
		hex: '#a15b85',
		value: 'hsla(324, 28%, 49%, 1)',
		id: 'S:af379e2e5aecaee277a7935b6ebd594fbd7d77f9,',
	},
	{
		name: 'coralColorChartsColor06',
		type: 'color',
		description: ``,
		hsla: 'hsla(280, 75%, 58%, 1)',
		hex: '#b045e5',
		value: 'hsla(280, 75%, 58%, 1)',
		id: 'S:b28f4af5673ace257313261d28057f2b48e44882,',
	},
	{
		name: 'coralColorChartsColor06Weak',
		type: 'color',
		description: ``,
		hsla: 'hsla(279, 77%, 88%, 1)',
		hex: '#e8caf8',
		value: 'hsla(279, 77%, 88%, 1)',
		id: 'S:d28944e5d2a0d6513385e36f2d2a29f4c736fd67,',
	},
	{
		name: 'coralColorChartsColor06Strong',
		type: 'color',
		description: ``,
		hsla: 'hsla(280, 54%, 36%, 1)',
		hex: '#6e2b8f',
		value: 'hsla(280, 54%, 36%, 1)',
		id: 'S:470f28a6ce87fee5f7de1ce57f6378da2d9172aa,',
	},
	{
		name: 'coralColorChartsColor06Hover',
		type: 'color',
		description: ``,
		hsla: 'hsla(280, 54%, 36%, 1)',
		hex: '#6e2b8f',
		value: 'hsla(280, 54%, 36%, 1)',
		id: 'S:77b1ffc55e4d9589312ddce873657d4e56457b1f,',
	},
	{
		name: 'coralColorChartsColor07',
		type: 'color',
		description: ``,
		hsla: 'hsla(4, 89%, 49%, 1)',
		hex: '#ea1b0e',
		value: 'hsla(4, 89%, 49%, 1)',
		id: 'S:2a7a643c04df162767b950d50085852ec82b3465,',
	},
	{
		name: 'coralColorChartsColor07Weak',
		type: 'color',
		description: ``,
		hsla: 'hsla(359, 69%, 73%, 1)',
		hex: '#e9898a',
		value: 'hsla(359, 69%, 73%, 1)',
		id: 'S:d060bb5d7716de1d5811173ae39fe440d17fedab,',
	},
	{
		name: 'coralColorChartsColor07Strong',
		type: 'color',
		description: ``,
		hsla: 'hsla(359, 62%, 43%, 1)',
		hex: '#b32a2c',
		value: 'hsla(359, 62%, 43%, 1)',
		id: 'S:d26fe825f80405e1247e46220e44ebacd760b0bc,',
	},
	{
		name: 'coralColorChartsColor07Hover',
		type: 'color',
		description: ``,
		hsla: 'hsla(359, 62%, 43%, 1)',
		hex: '#b32a2c',
		value: 'hsla(359, 62%, 43%, 1)',
		id: 'S:a9c71244bf611ee9f67a0254890a505184b78f6a,',
	},
	{
		name: 'coralColorChartsColor08',
		type: 'color',
		description: ``,
		hsla: 'hsla(22, 88%, 54%, 1)',
		hex: '#f16e23',
		value: 'hsla(22, 88%, 54%, 1)',
		id: 'S:e5b08742c7524533d54ed8b92417168cbb0d48b9,',
	},
	{
		name: 'coralColorChartsColor08Weak',
		type: 'color',
		description: ``,
		hsla: 'hsla(22, 88%, 84%, 1)',
		hex: '#facbb0',
		value: 'hsla(22, 88%, 84%, 1)',
		id: 'S:713a1ef8a20fa6aed2d1c434dc927f17e0d834bd,',
	},
	{
		name: 'coralColorChartsColor08Strong',
		type: 'color',
		description: ``,
		hsla: 'hsla(22, 75%, 42%, 1)',
		hex: '#b9541b',
		value: 'hsla(22, 75%, 42%, 1)',
		id: 'S:e5f922fd5942f5527ca496a0b5d7ef1112080036,',
	},
	{
		name: 'coralColorChartsColor08Hover',
		type: 'color',
		description: ``,
		hsla: 'hsla(22, 75%, 42%, 1)',
		hex: '#b9541b',
		value: 'hsla(22, 75%, 42%, 1)',
		id: 'S:ff9e7d61eea874a0d2fa0697f64ccbcb869d7bcf,',
	},
	{
		name: 'coralColorChartsColor09',
		type: 'color',
		description: ``,
		hsla: 'hsla(34, 34%, 45%, 1)',
		hex: '#99784c',
		value: 'hsla(34, 34%, 45%, 1)',
		id: 'S:3459f99731f6e21a0c346c703ce03d9662b31774,',
	},
	{
		name: 'coralColorChartsColor09Weak',
		type: 'color',
		description: ``,
		hsla: 'hsla(35, 28%, 82%, 1)',
		hex: '#ded3c4',
		value: 'hsla(35, 28%, 82%, 1)',
		id: 'S:0103d0ce726aa335bee66c373fc6c7c68314e42e,',
	},
	{
		name: 'coralColorChartsColor09Strong',
		type: 'color',
		description: ``,
		hsla: 'hsla(35, 34%, 27%, 1)',
		hex: '#5b482d',
		value: 'hsla(35, 34%, 27%, 1)',
		id: 'S:8e0e06029d5d12b605e62886ecba9ed9a23c6555,',
	},
	{
		name: 'coralColorChartsColor09Hover',
		type: 'color',
		description: ``,
		hsla: 'hsla(35, 34%, 27%, 1)',
		hex: '#5b482d',
		value: 'hsla(35, 34%, 27%, 1)',
		id: 'S:33467da234d07a52f1a321d511604be0085ee053,',
	},
	{
		name: 'coralColorNeutralBorderStrong',
		type: 'color',
		description: ``,
		hsla: 'hsla(0, 0%, 92%, 1)',
		hex: '#ebebeb',
		value: 'hsla(0, 0%, 92%, 1)',
		id: 'S:6cf482087de363ed74112bb720849d3cae540491,',
	},
	{
		name: 'coralColorNeutralBorderStrongHover',
		type: 'color',
		description: ``,
		hsla: 'hsla(216, 30%, 82%, 1)',
		hex: '#c3cedf',
		value: 'hsla(216, 30%, 82%, 1)',
		id: 'S:c9cdc827cbbdf0cd33bb0dfc754ed507ce7ec904,',
	},
	{
		name: 'coralColorNeutralIcon',
		type: 'color',
		description: ``,
		hsla: 'hsla(210, 17%, 93%, 1)',
		hex: '#eaedf0',
		value: 'hsla(210, 17%, 93%, 1)',
		id: 'S:ea491de561b1aad44427eab1639b4f67ed6af9cc,',
	},
	{
		name: 'coralColorNeutralIconInverted',
		type: 'color',
		description: ``,
		hsla: 'hsla(210, 7%, 79%, 1)',
		hex: '#c5c9cd',
		value: 'hsla(210, 7%, 79%, 1)',
		id: 'S:be4a8493d880e2ce69feb90d8d04e9251fefa640,',
	},
	{
		name: 'coralColorNeutralIconWeak',
		type: 'color',
		description: ``,
		hsla: 'hsla(206, 24%, 83%, 1)',
		hex: '#c8d4dd',
		value: 'hsla(206, 24%, 83%, 1)',
		id: 'S:193d2d0604570ca986711e869ecd6df674cba1bd,',
	},
	{
		name: 'coralColorChartsDefaultText',
		type: 'color',
		description: ``,
		hsla: 'hsla(205, 87%, 94%, 1)',
		hex: '#e3f2fd',
		value: 'hsla(205, 87%, 94%, 1)',
		id: 'S:95feb6e5caef73a4f8be717f657a0620cfe8c242,',
	},
	{
		name: 'coralColorChartsDefaultTextStrong',
		type: 'color',
		description: ``,
		hsla: 'hsla(205, 93%, 22%, 1)',
		hex: '#04426d',
		value: 'hsla(205, 93%, 22%, 1)',
		id: 'S:54d0b282048baf9da510f9fcbb010db00c1de5d3,',
	},
	{
		name: 'coralColorChartsDefaultTextWeak',
		type: 'color',
		description: ``,
		hsla: 'hsla(207, 93%, 94%, 1)',
		hex: '#e3f2fe',
		value: 'hsla(207, 93%, 94%, 1)',
		id: 'S:6a7d2aac345613dc7dc5cb90ed1a81654301fb77,',
	},
	{
		name: 'coralColorChartsColor09Text',
		type: 'color',
		description: ``,
		hsla: 'hsla(36, 36%, 5%, 1)',
		hex: '#130f09',
		value: 'hsla(36, 36%, 5%, 1)',
		id: 'S:659455accf5760a197feff3f6d718f5930787051,',
	},
	{
		name: 'coralColorChartsColor09TextStrong',
		type: 'color',
		description: ``,
		hsla: 'hsla(36, 36%, 5%, 1)',
		hex: '#130f09',
		value: 'hsla(36, 36%, 5%, 1)',
		id: 'S:236b1f146be3434b33302601113fb092484766bf,',
	},
	{
		name: 'coralColorChartsColor09TextWeak',
		type: 'color',
		description: ``,
		hsla: 'hsla(35, 28%, 82%, 1)',
		hex: '#ded3c4',
		value: 'hsla(35, 28%, 82%, 1)',
		id: 'S:7f2e610507e21b509888d51144abd8403c443ae4,',
	},
	{
		name: 'coralColorNeutralBackgroundHeavy',
		type: 'color',
		description: ``,
		hsla: 'hsla(204, 18%, 11%, 1)',
		hex: '#171d21',
		value: 'hsla(204, 18%, 11%, 1)',
		id: 'S:65df702aa0cdfdc3cac4d78123da59c2f4d83519,',
	},
	{
		name: 'coralColorIllustrationColor01',
		type: 'color',
		description: ``,
		hsla: 'hsla(358, 40%, 53%, 1)',
		hex: '#b8585c',
		value: 'hsla(358, 40%, 53%, 1)',
		id: 'S:4ba3c464f3e7a635ab7640ae0ebf5bf5839c4a2a,',
	},
	{
		name: 'coralColorIllustrationColor02',
		type: 'color',
		description: ``,
		hsla: 'hsla(355, 39%, 61%, 1)',
		hex: '#c2747a',
		value: 'hsla(355, 39%, 61%, 1)',
		id: 'S:37f1eae01dbb8626bfc383ac4645c148da5f13ed,',
	},
	{
		name: 'coralColorIllustrationColor03',
		type: 'color',
		description: ``,
		hsla: 'hsla(349, 15%, 71%, 1)',
		hex: '#c1abaf',
		value: 'hsla(349, 15%, 71%, 1)',
		id: 'S:9b29963cb9e511f47e652388948df4a65b6aa581,',
	},
	{
		name: 'coralColorIllustrationColor04',
		type: 'color',
		description: ``,
		hsla: 'hsla(211, 54%, 15%, 1)',
		hex: '#12273d',
		value: 'hsla(211, 54%, 15%, 1)',
		id: 'S:cd6ec85e18157192a80497e75669741be5033fca,',
	},
	{
		name: 'coralColorIllustrationColor05',
		type: 'color',
		description: ``,
		hsla: 'hsla(212, 28%, 37%, 1)',
		hex: '#455e7a',
		value: 'hsla(212, 28%, 37%, 1)',
		id: 'S:880a64f54ec715cf822e645d790b40a6c575db9e,',
	},
	{
		name: 'coralColorIllustrationColor06',
		type: 'color',
		description: ``,
		hsla: 'hsla(212, 29%, 61%, 1)',
		hex: '#7d99b8',
		value: 'hsla(212, 29%, 61%, 1)',
		id: 'S:6827b5c2ad9331c08b9057f3b4175bce503f6fb1,',
	},
	{
		name: 'coralColorIllustrationSkintone01',
		type: 'color',
		description: ``,
		hsla: 'hsla(20, 29%, 66%, 1)',
		hex: '#c2a08f',
		value: 'hsla(20, 29%, 66%, 1)',
		id: 'S:0efbd574980a36ce591b5448477b1172d1229bd8,',
	},
	{
		name: 'coralColorIllustrationSkintone02',
		type: 'color',
		description: ``,
		hsla: 'hsla(21, 23%, 49%, 1)',
		hex: '#99735f',
		value: 'hsla(21, 23%, 49%, 1)',
		id: 'S:22fe9c447a404340023bc84d572c0f9d2c8cb4e4,',
	},
	{
		name: 'coralColorIllustrationSkintone03',
		type: 'color',
		description: ``,
		hsla: 'hsla(17, 29%, 22%, 1)',
		hex: '#473027',
		value: 'hsla(17, 29%, 22%, 1)',
		id: 'S:277c7f8c53f16c317a3c8b02619b58bd887ee941,',
	},
	{
		name: 'coralColorIllustrationShadow',
		type: 'color',
		description: ``,
		hsla: 'hsla(0, 0%, 0%, 0.1)',
		hex: '#0000001f',
		value: 'hsla(0, 0%, 0%, 0.1)',
		id: 'S:c2d4a5aff8da216258237cee236516287b4430cf,',
	},
	{
		name: 'coralColorIllustrationColor07',
		type: 'color',
		description: ``,
		hsla: 'hsla(213, 13%, 35%, 1)',
		hex: '#4e5966',
		value: 'hsla(213, 13%, 35%, 1)',
		id: 'S:e6a32f9ebcd47f377de4f76b9f20cb98315cf209,',
	},
	{
		name: 'coralColorIllustrationColor08',
		type: 'color',
		description: ``,
		hsla: 'hsla(212, 13%, 19%, 1)',
		hex: '#2b3138',
		value: 'hsla(212, 13%, 19%, 1)',
		id: 'S:9ae7b3af0160051362455a2168ff8645a42f703b,',
	},
	{
		name: 'coralColorIllustrationColor09',
		type: 'color',
		description: ``,
		hsla: 'hsla(240, 3%, 12%, 1)',
		hex: '#1d1d1f',
		value: 'hsla(240, 3%, 12%, 1)',
		id: 'S:e73f099a6ec3332931b3c1f961795360426572a3,',
	},
	{
		name: 'coralColorAccentBackgroundSelected',
		type: 'color',
		description: ``,
		hsla: 'hsla(199, 73%, 13%, 1)',
		hex: '#092a39',
		value: 'hsla(199, 73%, 13%, 1)',
		id: 'S:e90340e641ca4e9da503dbae26e63f01ee15ba6a,',
	},
	{
		name: 'coralColorBrandText',
		type: 'color',
		description: ``,
		hsla: 'hsla(0, 0%, 100%, 1)',
		hex: '#ffffff',
		value: 'hsla(0, 0%, 100%, 1)',
		id: 'S:d9b4db049df4a13c6505a8245821011e32bed010,',
	},
	{
		name: 'coralColorBrandTextHover',
		type: 'color',
		description: ``,
		hsla: 'hsla(0, 0%, 100%, 1)',
		hex: '#ffffff',
		value: 'hsla(0, 0%, 100%, 1)',
		id: 'S:d1b7e7720cf0ed2ebe5dfa995b395f2fc051c72b,',
	},
	{
		name: 'coralColorBrandTextActive',
		type: 'color',
		description: ``,
		hsla: 'hsla(0, 0%, 100%, 1)',
		hex: '#ffffff',
		value: 'hsla(0, 0%, 100%, 1)',
		id: 'S:36357afae4a057baed96e9840d274a9798039129,',
	},
	{
		name: 'coralColorBrandTextInverted',
		type: 'color',
		description: ``,
		hsla: 'hsla(0, 0%, 38%, 1)',
		hex: '#616161',
		value: 'hsla(0, 0%, 38%, 1)',
		id: 'S:c1b0dcc4dfb5b0e6507f17eb566806be0437aba9,',
	},
	{
		name: 'coralColorBrandTextInvertedHover',
		type: 'color',
		description: ``,
		hsla: 'hsla(0, 0%, 13%, 1)',
		hex: '#202020',
		value: 'hsla(0, 0%, 13%, 1)',
		id: 'S:8b1aa5c9b617e6064abfa4ed095acdc6eb1e2865,',
	},
	{
		name: 'coralColorBrandTextInvertedActive',
		type: 'color',
		description: ``,
		hsla: 'hsla(0, 0%, 13%, 1)',
		hex: '#202020',
		value: 'hsla(0, 0%, 13%, 1)',
		id: 'S:cb0de99f17eb720080ebd854678df271d7c3c21a,',
	},
	{
		name: 'coralColorBrandTextSelected',
		type: 'color',
		description: ``,
		hsla: 'hsla(204, 96%, 18%, 1)',
		hex: '#023659',
		value: 'hsla(204, 96%, 18%, 1)',
		id: 'S:d5964e997b2bf6332dc2b3fc4e636e0e2246f372,',
	},
	{
		name: 'coralColorBrandBackgroundWeak',
		type: 'color',
		description: ``,
		hsla: 'hsla(0, 0%, 100%, 0)',
		hex: '#ffffff00',
		value: 'hsla(0, 0%, 100%, 0)',
		id: 'S:c3391e758de221c656756f472678d07818b8dcb8,',
	},
	{
		name: 'coralColorBrandBackgroundWeakHover',
		type: 'color',
		description: ``,
		hsla: 'hsla(0, 0%, 100%, 0.1)',
		hex: '#ffffff1f',
		value: 'hsla(0, 0%, 100%, 0.1)',
		id: 'S:46cd1240cbbd51a4920df09d91017e89614d2435,',
	},
	{
		name: 'coralColorBrandBackgroundWeakActive',
		type: 'color',
		description: ``,
		hsla: 'hsla(0, 0%, 100%, 0.1)',
		hex: '#ffffff1f',
		value: 'hsla(0, 0%, 100%, 0.1)',
		id: 'S:4056934c0f92ed878b14dcc69f1d06d43ca94315,',
	},
	{
		name: 'coralColorBrandBackgroundSelected',
		type: 'color',
		description: ``,
		hsla: 'hsla(0, 0%, 100%, 1)',
		hex: '#ffffff',
		value: 'hsla(0, 0%, 100%, 1)',
		id: 'S:12204f8141b2d867b7ed1fd4896c7899ca49a842,',
	},
	{
		name: 'coralColorBrandBackgroundInverted',
		type: 'color',
		description: ``,
		hsla: 'hsla(0, 0%, 13%, 0)',
		hex: '#20202000',
		value: 'hsla(0, 0%, 13%, 0)',
		id: 'S:4c6023974e1efb6fd9605ded5061dbe21efc52ac,',
	},
	{
		name: 'coralColorBrandBackgroundInvertedHover',
		type: 'color',
		description: ``,
		hsla: 'hsla(0, 0%, 13%, 0.1)',
		hex: '#2020201f',
		value: 'hsla(0, 0%, 13%, 0.1)',
		id: 'S:be496e916a988be4cd89a66c076f3d2a23eef370,',
	},
	{
		name: 'coralColorBrandBackgroundInvertedActive',
		type: 'color',
		description: ``,
		hsla: 'hsla(0, 0%, 13%, 0.1)',
		hex: '#2020201f',
		value: 'hsla(0, 0%, 13%, 0.1)',
		id: 'S:2f60f448e96ff45d0fd7e1b8c49d7255392e7216,',
	},
	{
		name: 'coralColorBrandBorder',
		type: 'color',
		description: ``,
		hsla: 'hsla(0, 0%, 100%, 1)',
		hex: '#ffffff',
		value: 'hsla(0, 0%, 100%, 1)',
		id: 'S:e9153d96d1349962e95db1a4420ee72e488c157a,',
	},
	{
		name: 'coralColorBrandBorderHover',
		type: 'color',
		description: ``,
		hsla: 'hsla(0, 0%, 100%, 1)',
		hex: '#ffffff',
		value: 'hsla(0, 0%, 100%, 1)',
		id: 'S:679f24a1a554ab833b1794ac795d6744c9252ca2,',
	},
	{
		name: 'coralColorBrandBorderActive',
		type: 'color',
		description: ``,
		hsla: 'hsla(0, 0%, 100%, 1)',
		hex: '#ffffff',
		value: 'hsla(0, 0%, 100%, 1)',
		id: 'S:55ca3f97765aa81f970cc305772d974d929094f9,',
	},
	{
		name: 'coralColorInfoText',
		type: 'color',
		description: ``,
		hsla: 'hsla(198, 72%, 65%, 1)',
		hex: '#66bfe6',
		value: 'hsla(198, 72%, 65%, 1)',
		id: 'S:6f3db30a46ffd296ab16f6ed8dc25bc2e03e697f,',
	},
	{
		name: 'coralColorInfoTextHover',
		type: 'color',
		description: ``,
		hsla: 'hsla(198, 72%, 55%, 1)',
		hex: '#3aaddf',
		value: 'hsla(198, 72%, 55%, 1)',
		id: 'S:7030b2c6e7b7e00b33aa9876cd64f3ffac9d291b,',
	},
	{
		name: 'coralColorInfoTextActive',
		type: 'color',
		description: ``,
		hsla: 'hsla(198, 72%, 45%, 1)',
		hex: '#2093c5',
		value: 'hsla(198, 72%, 45%, 1)',
		id: 'S:29a4e8bbd556ae686e212cfdec63568445c038f4,',
	},
	{
		name: 'coralColorInfoIcon',
		type: 'color',
		description: ``,
		hsla: 'hsla(198, 76%, 67%, 1)',
		hex: '#69c4eb',
		value: 'hsla(198, 76%, 67%, 1)',
		id: 'S:2646d355a4861045e9c49269b5c31f576f958685,',
	},
	{
		name: 'coralColorInfoTextWeak',
		type: 'color',
		description: ``,
		hsla: 'hsla(207, 18%, 24%, 1)',
		hex: '#323e48',
		value: 'hsla(207, 18%, 24%, 1)',
		id: 'S:a8f7a13273f34a14fae5a21486d6b88f21ea78fd,',
	},
	{
		name: 'coralColorInfoTextWeakHover',
		type: 'color',
		description: ``,
		hsla: 'hsla(199, 71%, 15%, 1)',
		hex: '#0b3142',
		value: 'hsla(199, 71%, 15%, 1)',
		id: 'S:a5c0f4e8600a443d2ad88e00fe975ba3d0897715,',
	},
	{
		name: 'coralColorInfoTextWeakActive',
		type: 'color',
		description: ``,
		hsla: 'hsla(199, 73%, 10%, 1)',
		hex: '#07202c',
		value: 'hsla(199, 73%, 10%, 1)',
		id: 'S:4676af4e2e6f128d0d91a964f73b5007b3a95991,',
	},
	{
		name: 'coralColorInfoTextStrong',
		type: 'color',
		description: ``,
		hsla: 'hsla(198, 72%, 75%, 1)',
		hex: '#91d1ed',
		value: 'hsla(198, 72%, 75%, 1)',
		id: 'S:9e79b3bdb022d479d862a328bea43869139fc5f6,',
	},
	{
		name: 'coralColorInfoTextStrongHover',
		type: 'color',
		description: ``,
		hsla: 'hsla(198, 72%, 65%, 1)',
		hex: '#66bfe6',
		value: 'hsla(198, 72%, 65%, 1)',
		id: 'S:2c61daf455b5d7b8f9d0079e2ed0bd86446c68ac,',
	},
	{
		name: 'coralColorInfoTextStrongActive',
		type: 'color',
		description: ``,
		hsla: 'hsla(198, 72%, 55%, 1)',
		hex: '#3aaddf',
		value: 'hsla(198, 72%, 55%, 1)',
		id: 'S:18cc5561d241cdcbde631bd6ce83cff5cfb66570,',
	},
	{
		name: 'coralColorInfoBackground',
		type: 'color',
		description: ``,
		hsla: 'hsla(198, 72%, 25%, 1)',
		hex: '#12516d',
		value: 'hsla(198, 72%, 25%, 1)',
		id: 'S:14870d03624d16eb044d220b5682225813fd667c,',
	},
	{
		name: 'coralColorInfoBackgroundHover',
		type: 'color',
		description: ``,
		hsla: 'hsla(199, 78%, 20%, 1)',
		hex: '#0b425b',
		value: 'hsla(199, 78%, 20%, 1)',
		id: 'S:1af64da0d0a40561f4d06788de331cfc2727ead9,',
	},
	{
		name: 'coralColorInfoBackgroundActive',
		type: 'color',
		description: ``,
		hsla: 'hsla(199, 73%, 10%, 1)',
		hex: '#07202c',
		value: 'hsla(199, 73%, 10%, 1)',
		id: 'S:5e66ec2e17b9a7538606b594e71c5ea4b921fb3b,',
	},
	{
		name: 'coralColorInfoBackgroundWeak',
		type: 'color',
		description: ``,
		hsla: 'hsla(207, 18%, 24%, 1)',
		hex: '#323e48',
		value: 'hsla(207, 18%, 24%, 1)',
		id: 'S:44020aee41cc9e6d79b3ffdc66e6ffbbfde3cdc7,',
	},
	{
		name: 'coralColorInfoBackgroundWeakHover',
		type: 'color',
		description: ``,
		hsla: 'hsla(199, 71%, 15%, 1)',
		hex: '#0b3142',
		value: 'hsla(199, 71%, 15%, 1)',
		id: 'S:e5dc43139c3c12f4678023973e64d2a0b26b037a,',
	},
	{
		name: 'coralColorInfoBackgroundWeakActive',
		type: 'color',
		description: ``,
		hsla: 'hsla(199, 73%, 10%, 1)',
		hex: '#07202c',
		value: 'hsla(199, 73%, 10%, 1)',
		id: 'S:9cc0c50389fcf2dafdf264e7ee6dee355388161b,',
	},
	{
		name: 'coralColorInfoBackgroundStrong',
		type: 'color',
		description: ``,
		hsla: 'hsla(198, 72%, 75%, 1)',
		hex: '#91d1ed',
		value: 'hsla(198, 72%, 75%, 1)',
		id: 'S:39a095f257498829c89e0388367390aa0f7b709d,',
	},
	{
		name: 'coralColorInfoBackgroundStrongHover',
		type: 'color',
		description: ``,
		hsla: 'hsla(198, 72%, 65%, 1)',
		hex: '#66bfe6',
		value: 'hsla(198, 72%, 65%, 1)',
		id: 'S:09d37ecaf187980c51ccfcbb4ecf7eae4618ebc4,',
	},
	{
		name: 'coralColorInfoBackgroundStrongActive',
		type: 'color',
		description: ``,
		hsla: 'hsla(198, 72%, 55%, 1)',
		hex: '#3aaddf',
		value: 'hsla(198, 72%, 55%, 1)',
		id: 'S:b57fa6cbea76791efcd07bac6cf2ff5deb6c35c0,',
	},
	{
		name: 'coralColorInfoBorder',
		type: 'color',
		description: ``,
		hsla: 'hsla(198, 72%, 75%, 1)',
		hex: '#91d1ed',
		value: 'hsla(198, 72%, 75%, 1)',
		id: 'S:452a566bdcbe14b34791b553864b0ac722e1ad43,',
	},
	{
		name: 'coralColorInfoBorderHover',
		type: 'color',
		description: ``,
		hsla: 'hsla(198, 72%, 65%, 1)',
		hex: '#66bfe6',
		value: 'hsla(198, 72%, 65%, 1)',
		id: 'S:a25ce8d97f9486f8d747293df4b73c6ffa88c6a1,',
	},
	{
		name: 'coralColorInfoBorderActive',
		type: 'color',
		description: ``,
		hsla: 'hsla(199, 72%, 55%, 1)',
		hex: '#3aacdf',
		value: 'hsla(199, 72%, 55%, 1)',
		id: 'S:a265bcbee6415fa251e00d2622acb4112913c5db,',
	},
	{
		name: 'coralColorInfoIconHover',
		type: 'color',
		description: ``,
		hsla: 'hsla(198, 76%, 57%, 1)',
		hex: '#3eb2e5',
		value: 'hsla(198, 76%, 57%, 1)',
		id: 'S:a10cbc0cfc8b0dcaebcdbec609557949e24bd24f,',
	},
	{
		name: 'coralColorInfoIconActive',
		type: 'color',
		description: ``,
		hsla: 'hsla(198, 77%, 47%, 1)',
		hex: '#1c9bd3',
		value: 'hsla(198, 77%, 47%, 1)',
		id: 'S:1101791c5475660c12c0360031f1bbbb9af53864,',
	},
	{
		name: 'coralColorBrandIcon',
		type: 'color',
		description: ``,
		hsla: 'hsla(0, 0%, 100%, 1)',
		hex: '#ffffff',
		value: 'hsla(0, 0%, 100%, 1)',
		id: 'S:b7e520cce22bea7edc6e062c7e54e77fcd959940,',
	},
	{
		name: 'coralColorBrandIconHover',
		type: 'color',
		description: ``,
		hsla: 'hsla(0, 0%, 100%, 1)',
		hex: '#ffffff',
		value: 'hsla(0, 0%, 100%, 1)',
		id: 'S:09e7d13ffd997d1059f6030f05c4423ef16c4847,',
	},
	{
		name: 'coralColorBrandIconActive',
		type: 'color',
		description: ``,
		hsla: 'hsla(0, 0%, 100%, 1)',
		hex: '#ffffff',
		value: 'hsla(0, 0%, 100%, 1)',
		id: 'S:41d8fb8ddaed9dfdc9eb801dcb4e0886ef5dea6d,',
	},
	{
		name: 'coralColorBrandIconInverted',
		type: 'color',
		description: ``,
		hsla: 'hsla(0, 0%, 38%, 1)',
		hex: '#616161',
		value: 'hsla(0, 0%, 38%, 1)',
		id: 'S:b1f2e9c5e470901288e952e0bd2ea2467c1635f8,',
	},
	{
		name: 'coralColorBrandIconInvertedHover',
		type: 'color',
		description: ``,
		hsla: 'hsla(0, 0%, 13%, 1)',
		hex: '#202020',
		value: 'hsla(0, 0%, 13%, 1)',
		id: 'S:99b04f690cc807d8305f91a422dab138cf6e0ac4,',
	},
	{
		name: 'coralColorBrandIconInvertedActive',
		type: 'color',
		description: ``,
		hsla: 'hsla(0, 0%, 13%, 1)',
		hex: '#202020',
		value: 'hsla(0, 0%, 13%, 1)',
		id: 'S:47e36a0519e66c66b2c8258757f1dbc0cc1727ea,',
	},
	{
		name: 'coralColorBrandIconSelected',
		type: 'color',
		description: ``,
		hsla: 'hsla(204, 96%, 18%, 1)',
		hex: '#023659',
		value: 'hsla(204, 96%, 18%, 1)',
		id: 'S:4f82d9b559d3c5db18c692a3869cc7e52657367c,',
	},
	{
		name: 'coralColorBrandingBackground',
		type: 'gradient',
		description: ``,
		value: 'linear-gradient(133deg,hsla(226, 49%, 14%, 1) 0%, hsla(253, 46%, 8%, 1) 100%)',
		id: 'S:bf314fa1e5204e02f67ed4064f24d642d1fc9efa,',
	},
	{
		name: 'coralColorBrandingNavigation',
		type: 'gradient',
		description: ``,
		value: 'linear-gradient(133deg,hsla(222, 49%, 14%, 1) 0%, hsla(253, 46%, 8%, 1) 100%)',
		id: 'S:1fa5a7a976d98a462474b9f529662749f847cdd0,',
	},
	{
		name: 'coralColorBrandBackground',
		type: 'gradient',
		description: ``,
		value: 'linear-gradient(133deg,hsla(210, 62%, 26%, 1) 0%, hsla(254, 47%, 23%, 1) 100%)',
		id: 'S:f3b995fb9442e71d002302b49f324dd0a277fbc3,',
	},
	{
		name: 'coralSpacingXxs',
		type: 'measure',
		description: ``,
		value: '0.25rem',
		id: 'c1e38f11-415e-11ec-8de5-f7dcd20b9ace',
	},
	{
		name: 'coralSpacingXs',
		type: 'measure',
		description: ``,
		value: '0.5rem',
		id: '7b7551d0-b4d6-11ec-a885-f33e1144cd00',
	},
	{
		name: 'coralSpacingS',
		type: 'measure',
		description: ``,
		value: '0.75rem',
		id: '7ee76e20-b4d6-11ec-80ec-81d7ed62932a',
	},
	{
		name: 'coralSpacingM',
		type: 'measure',
		description: ``,
		value: '1rem',
		id: '86ce70c0-b4d6-11ec-b76b-3da590a15504',
	},
	{
		name: 'coralSpacingL',
		type: 'measure',
		description: ``,
		value: '1.75rem',
		id: '8aa3bbb0-b4d6-11ec-b930-0b6aacdff92c',
	},
	{
		name: 'coralSpacingXl',
		type: 'measure',
		description: ``,
		value: '2.25rem',
		id: '8f1ac4e0-b4d6-11ec-9806-69893358e985',
	},
	{
		name: 'coralSizingMinimal',
		type: 'measure',
		description: ``,
		value: '0.75rem',
		id: '9981e2b0-b4d6-11ec-ac1e-2b6d1d6a2c7f',
	},
	{
		name: 'coralSizingXxxs',
		type: 'measure',
		description: ``,
		value: '1rem',
		id: 'bfda7990-b4d6-11ec-9c65-b1b879a05039',
	},
	{
		name: 'coralSizingXxs',
		type: 'measure',
		description: ``,
		value: '1.25rem',
		id: 'c350b490-b4d6-11ec-9d5d-ad9dbd31768f',
	},
	{
		name: 'coralSizingXs',
		type: 'measure',
		description: ``,
		value: '1.5rem',
		id: 'c8c1ae20-b4d6-11ec-a8ef-9de523cb52d2',
	},
	{
		name: 'coralSizingS',
		type: 'measure',
		description: ``,
		value: '1.75rem',
		id: 'cc3b6b90-b4d6-11ec-8b31-1791d0a18d04',
	},
	{
		name: 'coralSizingM',
		type: 'measure',
		description: ``,
		value: '2.25rem',
		id: 'd5d26820-b4d6-11ec-b6e7-13f783838bd4',
	},
	{
		name: 'coralSizingL',
		type: 'measure',
		description: ``,
		value: '2.5rem',
		id: 'd9cb1990-b4d6-11ec-868e-75c32f231580',
	},
	{
		name: 'coralSizingXxxl',
		type: 'measure',
		description: ``,
		value: '13.75rem',
		id: 'dddb71b0-b4d6-11ec-a762-a9e3930b8774',
	},
	{
		name: 'coralSizingMaximal',
		type: 'measure',
		description: ``,
		value: '20rem',
		id: 'e21f0ed0-b4d6-11ec-bb22-090b530f3237',
	},
	{
		name: 'coralSizingBrandingLogo',
		type: 'branding',
		description: ``,
		value: '1.75rem',
	},
	{
		name: 'coralElevationShadowNeutralM',
		type: 'shadow',
		description: ``,
		value: '0rem 0.125rem 0.375rem 0rem hsla(0, 0%, 0%, 0.5)',
		id: 'S:1e46bcc3593665ea527e656cb28e857f111e6864,:shadow:0',
	},
	{
		name: 'coralElevationShadowNeutralL',
		type: 'shadow',
		description: ``,
		value: '0rem 0.25rem 0.5rem 0rem hsla(0, 0%, 0%, 0.5)',
		id: 'S:8bf21eea402fda80510e8657d5d8db538640bd02,:shadow:0',
	},
	{
		name: 'coralElevationShadowAccent',
		type: 'shadow',
		description: ``,
		value: '0rem 0.0625rem 0.0625rem 0rem hsla(198, 72%, 75%, 0.3)',
		id: 'S:fe0699876a0912d91d178c69d81969b011a5eb58,:shadow:0',
	},
	{
		name: 'coralElevationShadowSuccess',
		type: 'shadow',
		description: ``,
		value: '0rem 0.0625rem 0.0625rem 0rem hsla(110, 50%, 70%, 0.3)',
		id: 'S:9ca8c51ead5e415ff9677d8bb4aeb39b28a7cb21,:shadow:0',
	},
	{
		name: 'coralElevationShadowDanger',
		type: 'shadow',
		description: ``,
		value: '0rem 0.0625rem 0.0625rem 0rem hsla(359, 100%, 78%, 0.3)',
		id: 'S:96007327fd92b029a90eca0a30ca2b30249911e1,:shadow:0',
	},
	{
		name: 'coralElevationShadowWarning',
		type: 'shadow',
		description: ``,
		value: '0rem 0.0625rem 0.0625rem 0rem hsla(27, 98%, 67%, 0.3)',
		id: 'S:f112889f1f57915b2f906b24fc07133ad0da4705,:shadow:0',
	},
	{
		name: 'coralElevationShadowBeta',
		type: 'shadow',
		description: ``,
		value: '0rem 0.0625rem 0.0625rem 0rem hsla(279, 34%, 78%, 0.3)',
		id: 'S:2f8bea6090298b26e6c486703d4285e7b76433fc,:shadow:0',
	},
	{
		name: 'coralElevationShadowNeutralInvertedM',
		type: 'shadow',
		description: ``,
		value: '0rem -0.125rem 0.375rem 0rem hsla(0, 0%, 2%, 0.5)',
		id: 'S:a5099a594218ccacd1f632af854309e6422c7f83,:shadow:0',
	},
	{
		name: 'coralElevationShadowNeutralInvertedL',
		type: 'shadow',
		description: ``,
		value: '0rem -0.25rem 0.5rem 0rem hsla(0, 0%, 5%, 0.5)',
		id: 'S:4a469b9d512c8d4b89bd6f9cf8c40fc2a40b921d,:shadow:0',
	},
	{
		name: 'coralElevationShadowNeutralS',
		type: 'shadow',
		description: ``,
		value: '0rem 0.0625rem 0.125rem 0rem hsla(0, 0%, 0%, 0.5)',
		id: 'S:c248e5315e126cc17860b114f6516a07a7832de1,:shadow:0',
	},
	{
		name: 'coralElevationShadowNeutralInvertedS',
		type: 'shadow',
		description: ``,
		value: '0rem -0.0625rem 0.125rem 0rem hsla(0, 0%, 2%, 0.5)',
		id: 'S:87123d2a6072733369a2eff12b6c5ddfbe208320,:shadow:0',
	},
	{
		name: 'coralElevationShadowInfo',
		type: 'shadow',
		description: ``,
		value: '0rem 0.0625rem 0.0625rem 0rem hsla(198, 72%, 75%, 0.3)',
		id: 'S:639dbb4a79fe62ae490cc885e4bcfd2db617e481,:shadow:0',
	},
	{
		name: 'coralHeadingL',
		type: 'typography',
		description: ``,
		value: `600 1.125rem/140% 'Source Sans Pro'`,
		fontStyle: 'normal',
		fontWeight: '600',
		fontSize: '1.125rem',
		lineHeight: '140%',
		fontFamily: 'Source Sans Pro',
		id: 'S:3e880348927c5dafc591f6ea24c9583b5372a076,',
	},
	{
		name: 'coralHeadingM',
		type: 'typography',
		description: ``,
		value: `600 1rem/140% 'Source Sans Pro'`,
		fontStyle: 'normal',
		fontWeight: '600',
		fontSize: '1rem',
		lineHeight: '140%',
		fontFamily: 'Source Sans Pro',
		id: 'S:fd2a41bdd7889fa1dcca1d3725ba080f235deb8d,',
	},
	{
		name: 'coralHeadingS',
		type: 'typography',
		description: ``,
		value: `600 0.875rem/140% 'Source Sans Pro'`,
		fontStyle: 'normal',
		fontWeight: '600',
		fontSize: '0.875rem',
		lineHeight: '140%',
		fontFamily: 'Source Sans Pro',
		id: 'S:a64f9cf77e1f6963661c1715744ad848e5da28bf,',
	},
	{
		name: 'coralParagraphM',
		type: 'typography',
		description: ``,
		value: `400 0.875rem/140% 'Source Sans Pro'`,
		fontStyle: 'normal',
		fontWeight: '400',
		fontSize: '0.875rem',
		lineHeight: '140%',
		fontFamily: 'Source Sans Pro',
		id: 'S:917d3089d5c99880f093dedfe802634dc734e627,',
	},
	{
		name: 'coralParagraphMBold',
		type: 'typography',
		description: ``,
		value: `600 0.875rem/140% 'Source Sans Pro'`,
		fontStyle: 'normal',
		fontWeight: '600',
		fontSize: '0.875rem',
		lineHeight: '140%',
		fontFamily: 'Source Sans Pro',
		id: 'S:9c15e3df6a89629144480cfd86b06a8a351e6abf,',
	},
	{
		name: 'coralParagraphS',
		type: 'typography',
		description: ``,
		value: `400 0.75rem/140% 'Source Sans Pro'`,
		fontStyle: 'normal',
		fontWeight: '400',
		fontSize: '0.75rem',
		lineHeight: '140%',
		fontFamily: 'Source Sans Pro',
		id: 'S:9cba41ba25fb01755b4d07eb823f6707a0cd6d4e,',
	},
	{
		name: 'coralParagraphSBold',
		type: 'typography',
		description: ``,
		value: `600 0.75rem/140% 'Source Sans Pro'`,
		fontStyle: 'normal',
		fontWeight: '600',
		fontSize: '0.75rem',
		lineHeight: '140%',
		fontFamily: 'Source Sans Pro',
		id: 'S:db3cc8d49445a71b0dfd4909d1e1dea7f9f9bfc2,',
	},
	{
		name: 'coralDataM',
		type: 'typography',
		description: ``,
		value: `400 0.875rem/140% 'Inconsolata'`,
		fontStyle: 'normal',
		fontWeight: '400',
		fontSize: '0.875rem',
		lineHeight: '140%',
		fontFamily: 'Inconsolata',
		id: 'S:ea21655f2b042b6b265a99861bf271192c475900,',
	},
	{
		name: 'coralDataMBold',
		type: 'typography',
		description: ``,
		value: `700 0.875rem/140% 'Inconsolata'`,
		fontStyle: 'normal',
		fontWeight: '700',
		fontSize: '0.875rem',
		lineHeight: '140%',
		fontFamily: 'Inconsolata',
		id: 'S:f2c5af46bfeef76f4e644aa0384b2994709f09d6,',
	},
	{
		name: 'coralLinkMUnderlined',
		type: 'typography',
		description: ``,
		value: `600 0.875rem/140% 'Source Sans Pro'`,
		fontStyle: 'normal',
		fontWeight: '600',
		fontSize: '0.875rem',
		lineHeight: '140%',
		fontFamily: 'Source Sans Pro',
		id: 'S:0459de0ba9f93a99351a262ad56b37a7141df5db,',
	},
	{
		name: 'coralLinkM',
		type: 'typography',
		description: ``,
		value: `600 0.875rem/140% 'Source Sans Pro'`,
		fontStyle: 'normal',
		fontWeight: '600',
		fontSize: '0.875rem',
		lineHeight: '140%',
		fontFamily: 'Source Sans Pro',
		id: 'S:f8714939f99dbb050689d7a9439bbd3d805d3248,',
	},
	{
		name: 'coralDataXl',
		type: 'typography',
		description: ``,
		value: `400 1.5rem/140% 'Inconsolata'`,
		fontStyle: 'normal',
		fontWeight: '400',
		fontSize: '1.5rem',
		lineHeight: '140%',
		fontFamily: 'Inconsolata',
		id: 'S:7a19acd294788646fc2263162aa038f44307a9bb,',
	},
	{
		name: 'coralLinkS',
		type: 'typography',
		description: ``,
		value: `600 0.75rem/140% 'Source Sans Pro'`,
		fontStyle: 'normal',
		fontWeight: '600',
		fontSize: '0.75rem',
		lineHeight: '140%',
		fontFamily: 'Source Sans Pro',
		id: 'S:6a212dca74018c7d3a3c6b15de797bfdac01fbf4,',
	},
	{
		name: 'coralLinkSUnderlined',
		type: 'typography',
		description: ``,
		value: `600 0.75rem/140% 'Source Sans Pro'`,
		fontStyle: 'normal',
		fontWeight: '600',
		fontSize: '0.75rem',
		lineHeight: '140%',
		fontFamily: 'Source Sans Pro',
		id: 'S:c3d95ef306b71418c1519b0d7f1b51e7862ff56a,',
	},
	{
		name: 'coralRadiusM',
		type: 'radius',
		description: ``,
		value: '0.5rem',
		id: '85681e80-415d-11ec-8de5-f7dcd20b9ace',
	},
	{
		name: 'coralRadiusL',
		type: 'radius',
		description: ``,
		value: '1rem',
		id: '95ba6ef0-415d-11ec-8de5-f7dcd20b9ace',
	},
	{
		name: 'coralRadiusRound',
		type: 'radius',
		description: ``,
		value: '6249.9375rem',
		id: '9bbf9231-415d-11ec-8de5-f7dcd20b9ace',
	},
	{
		name: 'coralRadiusS',
		type: 'radius',
		description: ``,
		value: '0.25rem',
		id: '65982381-4783-11ec-a826-6db8532cd4e8',
	},
	{
		name: 'coralBorderSSolid',
		type: 'border',
		description: ``,
		value: `1px solid`,
		id: 'e53f87c1-415e-11ec-8de5-f7dcd20b9ace',
	},
	{
		name: 'coralBorderMSolid',
		type: 'border',
		description: ``,
		value: `2px solid`,
		id: 'e9d78671-415e-11ec-8de5-f7dcd20b9ace',
	},
	{
		name: 'coralBorderSDashed',
		type: 'border',
		description: ``,
		value: `1px dashed`,
		id: 'ee9dc111-415e-11ec-8de5-f7dcd20b9ace',
	},
	{
		name: 'coralBorderMDashed',
		type: 'border',
		description: ``,
		value: `2px dashed`,
		id: 'f6993610-415e-11ec-8de5-f7dcd20b9ace',
	},
	{
		name: 'coralOpacityL',
		type: 'opacity',
		description: ``,
		value: `0.2`,
		id: '0c7b52b0-415f-11ec-8de5-f7dcd20b9ace',
	},
	{
		name: 'coralOpacityM',
		type: 'opacity',
		description: ``,
		value: `0.4`,
		id: '10bd9041-415f-11ec-8de5-f7dcd20b9ace',
	},
	{
		name: 'coralOpacityS',
		type: 'opacity',
		description: ``,
		value: `0.6`,
		id: '15f35591-415f-11ec-8de5-f7dcd20b9ace',
	},
	{
		name: 'coralBreakpointS',
		type: 'breakpoint',
		description: ``,
		value: `40em`,
		id: '20cb0f81-415f-11ec-8de5-f7dcd20b9ace',
	},
	{
		name: 'coralBreakpointM',
		type: 'breakpoint',
		description: ``,
		value: `48em`,
		id: '27f774b1-415f-11ec-8de5-f7dcd20b9ace',
	},
	{
		name: 'coralBreakpointL',
		type: 'breakpoint',
		description: ``,
		value: `64em`,
		id: '2dc50d31-415f-11ec-8de5-f7dcd20b9ace',
	},
	{
		name: 'coralBreakpointXl',
		type: 'breakpoint',
		description: ``,
		value: `80em`,
		id: '36958571-415f-11ec-8de5-f7dcd20b9ace',
	},
	{
		name: 'coralBrandingLogo',
		type: 'branding',
		description: ``,
		value: `url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAA4CAYAAACohjseAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAQ3SURBVHgB7Zu/UxNBFMe/e6ahQ0qxiBpaQWfUTjM0aqMMnWMh1iJEeyHBXiLqjDM6IP+A0Dk2Gkq0EMaxkhmuADsgNmZGgfW9vZz5dUcul938uPGbCbnb+5H95L3bu33vIaBZMpXqxT6GADEIIYcgaFmilzbFq3a1aZtN2/KQIkdHrovn2Rw0S0CDilBJOtskrRKcAgqjPL1zEGJZzM0uQoOaAlRghwQlkUJ4KD/ZYNg/yIiXWRshFQrQMFjN11EvM/iNxTCgDQPK8dQIHbUA82DV2iTXzTTquoEBldUkpslyKbRTFmap1zMim80H2T0QIMHFCWyJAIfQGdqka3M4iMvWBVRwB/iI2mG+3QoEeSRgB8O5qgvpC9gFcK6OhPQEVAPKAb6g8+EcCeqrRZAeA4/leQCPlt0Cx5I4R+8pr001FpT3U2P0sYDuk6TXKD3PLpc3VlhQXXdQ1jOn61eBvj4YkKDXE3V5lanSRQ9xByZd89IFArwGDJyBIZ2ih/6KB5F/gMp6EmmYUk+PA2daAhPlVixZcN8gHMuca1breLkVS4ACV2BKDJc0d/oalVlRARZHzjhMiOFa4ZqVoumcUL+oa8Gb0C2+5m7fagccS0DKSWcByoJ70DW/Y7DkZccledlLGxvAzm5l2y6tv3sPjdrDMZyO0QQ2CV1woyN0K7joD+YqkaB3VdvOjm5AFfyKqTmeltATnFFya9tZHkj471coAL8KlW1fv0G7JANaGkfP1/POJ4OmH/nv93YJWP0MwxLEdpYHmVbHVloniskyYBxRFQWcow1IbBYirv+A3S4GtBFd2ZZKX0VVkgGBdURVAj/ZgmuIpiSFYFYsoowqIFtwzUJMAUbxOsxzStwqRoOjaMUV/uPcByWeIlqSnOfnBQcwRrnwVrqp+eia7WaCFaByU51W5AltoeC/PeExGU5QMLi/H5qUcxdiKC1lKaPEgZrm54cMxzN7v1k9t3NAiuMwHN5g4JME951iNc9eoElJSqfNuCsVwQqKz6SpRU9ugt1w4l5wd+Qf5dW8E5BqRhIZGj3T7mrlwzZbkROKOsTWmSNrrH7iL/UXg3GwKf24eTju+z7elDfUps+cMpEl6BRbUbnhiVLEbesHsL2tA8oVj5x3q8tMvDO84yku1WhvuUijksiSaz6obvaeD8aQUWnh7tGm6rOHPAHVbcPCKHRdj2blFCH4FAYFKSP5AE4sdqbCl5G46mDIQIVAdWMyZHqbkhjD6CR35fEhYClXoKBTEfI8j1Q4+q5mXtwHKxgcq/FySidZyjUprXbZTYJ7WF0mUk9hC2Lj9MQwRkdPhT1HA3ImAvSUFbSEslzNljQz6HQxvx+HXtimwFxp65ByXYkbdMYkSjOSRs+fLwbBGCzXDBhCdiCQilnjQXqzZXvpW+KotbCtYrIc9JJijf+tgONDOqDK9RfJ1nAWmpwCzwAAAABJRU5ErkJggg==')`,
		id: 'bc401250-4789-11ec-a826-6db8532cd4e8',
	},
	{
		name: 'coralTransitionInstant',
		type: 'transition',
		description: ``,
		value: `100ms ease-out`,
		id: 'c40577a1-5d8c-11ec-9f08-61882f73ab2c',
	},
	{
		name: 'coralTransitionFast',
		type: 'transition',
		description: ``,
		value: `250ms ease-in-out`,
		id: 'cc39d6f1-5d8c-11ec-9f08-61882f73ab2c',
	},
	{
		name: 'coralTransitionNormal',
		type: 'transition',
		description: ``,
		value: `300ms ease-in-out`,
		id: 'd342ae91-5d8c-11ec-9f08-61882f73ab2c',
	},
	{
		name: 'coralTransitionSlow',
		type: 'transition',
		description: ``,
		value: `400ms ease-in`,
		id: 'e0c90dc1-5d8c-11ec-9f08-61882f73ab2c',
	},
	{
		name: 'coralElevationLayerFlat',
		type: 'elevation',
		description: ``,
		value: `0`,
		id: '058a62d1-5d8d-11ec-9f08-61882f73ab2c',
	},
	{
		name: 'coralElevationLayerStandardFront',
		type: 'elevation',
		description: ``,
		value: `4`,
		id: '1356f2c1-5d8d-11ec-9f08-61882f73ab2c',
	},
	{
		name: 'coralElevationLayerInteractiveFront',
		type: 'elevation',
		description: ``,
		value: `8`,
		id: '1aefae51-5d8d-11ec-9f08-61882f73ab2c',
	},
	{
		name: 'coralElevationLayerOverlay',
		type: 'elevation',
		description: ``,
		value: `16`,
		id: '2096d311-5d8d-11ec-9f08-61882f73ab2c',
	},
	{
		name: 'coralAnimationHeartbeat',
		type: 'animation',
		description: ``,
		value: `coral-dark-keyframes-blink 1.5s cubic-bezier(0.7, 0, 1, 1) infinite`,
		id: '1410db90-9401-11ec-a001-db4d7ae8c1be',
	},
];

export default dictionary;
